export const enTranslations = {
  // ===========================================
  // SEO Meta Tags - English
  // ===========================================
  
  // Site-wide SEO
  'seo.siteName': 'Hudan Lil Muttaqeen - Quran & Arabic Learning Platform',
  
  // Homepage SEO
  'seo.home.title': 'Learn Quran Online — Tajweed, Hifz & Arabic | Hudan',
  'seo.home.description': 'Live 1-on-1 Quran classes with Ijazah-certified teachers. Tajweed, Hifz and Arabic for kids and adults. Book a free trial session today.',
  'seo.home.keywords': 'learn Quran online, Tajweed lessons, Quran memorization, learn Arabic, Quran teacher, Quran classes for kids, Quran recitation, Islamic education, online Quran learning, Islamic learning platform',
  
  // About Page SEO
  'seo.about.title': 'About Hudan Lil Muttaqeen | Our Mission in Quran & Arabic Education',
  'seo.about.description': 'Learn about Hudan Lil Muttaqeen - a leading educational platform connecting students with qualified Quran and Arabic teachers worldwide. Discover our vision, mission, and core values.',
  'seo.about.keywords': 'about Hudan platform, Quran education, qualified teachers, educational vision, online Islamic education, Quranic platform, learn classical Arabic',
  
  // Courses Page SEO
  'seo.courses.title': 'Online Quran Courses — Tajweed, Hifz & Arabic | Hudan',
  'seo.courses.description': '50+ structured courses: Tajweed for beginners, Hifz programs, Noorani Qaida for kids, Tafsir and Quranic Arabic. Learn live with expert teachers.',
  'seo.courses.keywords': 'Tajweed courses, Quran memorization courses, Tafsir Quran, learn Quranic Arabic, kids classes, online Islamic courses, recitation learning, Qiraat courses',
  
  // Teachers Page SEO
  'seo.teachers.title': 'Quran Teachers Online — Ijazah-Certified Tutors | Hudan',
  'seo.teachers.description': 'Browse 30+ male and female Quran teachers with Ijazah. Filter by specialty, language and price — book a free 30-minute trial with your tutor.',
  'seo.teachers.keywords': 'Quran teacher, Tajweed tutor, Hifz teacher, Arabic tutor, Ijazah certified, online tutor, Qiraat Sheikh, children teacher',
  
  // Student Portal SEO
  'seo.studentPortal.title': 'Student Portal | Dashboard & Classes - Hudan Lil Muttaqeen',
  'seo.studentPortal.description': 'Access your student portal to track lessons, class schedule, memorization progress, and communicate with your teachers.',
  'seo.studentPortal.keywords': 'student portal, dashboard, lesson tracking, class schedule, learning progress',
  
  // Teacher Portal SEO  
  'seo.teacherPortal.title': 'Teacher Portal | Student & Class Management - Hudan Lil Muttaqeen',
  'seo.teacherPortal.description': 'Teacher portal for managing students, class schedules, and tracking student progress in Quran and Arabic learning.',
  'seo.teacherPortal.keywords': 'teacher portal, student management, class schedule, progress tracking, online teaching',
  
  // Login Page SEO
  'seo.login.title': 'Login | Hudan Lil Muttaqeen - Quran & Arabic Learning Platform',
  'seo.login.description': 'Sign in to your Hudan Lil Muttaqeen account to access your lessons and continue your journey in learning the Quran and Arabic language.',
  'seo.login.keywords': 'login, student account, teacher account, educational platform',
  
  // Register Page SEO
  'seo.register.title': 'Register | Hudan Lil Muttaqeen',
  'seo.register.description': 'Create your free account on Hudan Lil Muttaqeen — start learning Quran with certified teachers today.',
  'seo.register.keywords': 'register account, create account, new student, new teacher, join platform',
  'seo.register.student.title': 'Register as Student | Hudan',
  'seo.register.student.description': 'Join Hudan as a student — book sessions with certified Quran teachers in your timezone.',
  'seo.register.teacher.title': 'Become a Quran Teacher | Hudan',
  'seo.register.teacher.description': 'Teach Quran online with Hudan — share your Ijazah, set your rates, and reach students worldwide.',
  'seo.register.parent.title': 'Register as Parent | Hudan',
  'seo.register.parent.description': 'Open a family account on Hudan — enrol your children, choose their Quran teacher, and follow their progress.',

  // Terms Page SEO (noindex)
  'seo.terms.title': 'Terms of Service | Hudan',
  'seo.terms.description': 'Read the Terms of Service for Hudan Lil Muttaqeen — your rights, responsibilities, and our commitments when using our Quran-learning platform.',

  // Privacy Page SEO (noindex)
  'seo.privacy.title': 'Privacy Policy | Hudan',
  'seo.privacy.description': 'How Hudan Lil Muttaqeen collects, uses, and protects your personal data. GDPR-compliant and transparent.',

  // Blog Index SEO
  'seo.blog.title': 'Hudan Blog — Quran, Tajweed & Arabic Learning',
  'seo.blog.description': 'Articles on learning Quran online, Tajweed, memorization, and Arabic — written by certified teachers.',
  'seo.blog.keywords': 'Quran blog, Tajweed articles, Hifz tips, learn Arabic, Islamic education blog',

  // ===========================================
  // Navigation
  // ===========================================
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.courses': 'Courses',
  'nav.teachers': 'Teachers',
  'nav.login': 'Login',
  'nav.register': 'Register',

  // ===========================================
  // Hero Section
  // ===========================================
  'hero.title': 'Learn Qur\'an with Expert Teachers',
  'hero.subtitle': 'Hudan Lil Muttaqeen connects dedicated students with qualified Qur\'an teachers for personalized learning experiences.',
  'hero.findTeacher': 'Find a Teacher',
  'hero.becomeTeacher': 'Become a Teacher',
  'hero.personalizedLessons': 'Personalized Lessons',
  'hero.qualifiedTeachers': 'Qualified Teachers',
  'hero.flexibleSchedule': 'Flexible Schedule',

  // ===========================================
  // Teachers Section
  // ===========================================
  'teachers.featured': 'Our Featured Teachers',
  'teachers.featuredDesc': 'Learn with our highly-rated teachers who are experts in Qur\'anic studies and dedicated to helping students succeed.',
  'teachers.viewAll': 'View All Teachers',

  // ===========================================
  // Testimonials Section
  // ===========================================
  'testimonials.title': 'What Our Students Say',
  'testimonials.subtitle': 'Hear from our community about their experiences learning with our qualified teachers.',

  // ===========================================
  // CTA Section
  // ===========================================
  'cta.title': 'Ready to Start Your Qur\'anic Journey?',
  'cta.subtitle': 'Whether you\'re looking to learn Qur\'an or share your knowledge as a teacher, Hudan Lil Muttaqeen provides the platform to connect and excel.',
  'cta.forStudents': 'For Students',
  'cta.forTeachers': 'For Teachers',
  
  // ===========================================
  // Footer
  // ===========================================
  'footer.description': 'Hudan Lil Muttaqeen is dedicated to providing the highest quality Quran and Arabic language education to learners worldwide.',
  'footer.quickLinks': 'Quick Links',
  'footer.contactUs': 'Contact Us',
  'footer.rights': 'All rights reserved.',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.termsOfService': 'Terms of Service',
  'footer.faq': 'FAQ',
  
  // ===========================================
  // Home Page Content
  // ===========================================
  'home.welcomeMessage': 'Welcome to Hudan Lil Muttaqeen',
  'home.heroTitle': 'Your Journey to Master the Holy Quran Starts Here',
  'home.heroSubtitle': 'Learn Quran recitation, Tajweed, Hifz, and Arabic language with elite qualified teachers from across the Islamic world',
  'home.learnWithBestTeachers': 'Learn with the best Quran and Arabic teachers from around the world',
  'home.startLearning': 'Start Your Learning Journey',
  'home.exploreTeachers': 'Explore Teachers',
  'home.viewCourses': 'View Courses',
  
  // How It Works Section
  'home.howItWorks': 'How It Works',
  'home.howItWorks.subtitle': 'Four simple steps to begin your journey in learning the Holy Quran and Arabic language',
  'home.step1.title': 'Create Your Free Account',
  'home.step1.desc': 'Register on the platform and complete your profile with your learning goals and current level',
  'home.step2.title': 'Choose Your Perfect Teacher',
  'home.step2.desc': 'Browse teacher profiles and select the best fit based on their specialty, schedule, and student reviews',
  'home.step3.title': 'Book Your Sessions',
  'home.step3.desc': 'Choose convenient times and book individual or group sessions according to your needs',
  'home.step4.title': 'Start Learning',
  'home.step4.desc': 'Connect with your teacher via the virtual classroom and begin your journey to Quran mastery',
  
  // Features Section
  'home.features.title': 'Why Choose Hudan Lil Muttaqeen?',
  'home.features.subtitle': 'A comprehensive platform for Quran and Arabic education with the highest standards',
  'home.feature1.title': 'Qualified Teachers',
  'home.feature1.desc': 'All our teachers hold Ijazah certifications and accredited teaching credentials',
  'home.feature2.title': 'Flexible Learning',
  'home.feature2.desc': 'Flexible class schedules that fit your time wherever you are in the world',
  'home.feature3.title': 'Interactive Lessons',
  'home.feature3.desc': 'Modern virtual classrooms with interactive tools for recitation and correction',
  'home.feature4.title': 'Continuous Tracking',
  'home.feature4.desc': 'Regular progress reports and continuous assessment of your level',
  
  // Testimonials
  'home.testimonials.title': 'What Our Students Say',
  'home.testimonials.subtitle': 'Success stories from our students around the world',
  
  // CTA Section
  'home.cta.title': 'Start Your Quran Learning Journey Today',
  'home.cta.subtitle': 'Join thousands of students learning the Holy Quran and Arabic language with Hudan Lil Muttaqeen',
  'home.cta.registerStudent': 'Register as Student',
  'home.cta.registerTeacher': 'Join as Teacher',
  
  // ===========================================
  // Teachers Page
  // ===========================================
  'teachers.title': 'Our Qualified Teachers',
  'teachers.subtitle': 'Choose from elite certified Quran and Arabic teachers',
  'teachers.search': 'Search for a teacher...',
  'teachers.subject': 'Specialty',
  'teachers.priceRange': 'Price Range',
  'teachers.viewProfile': 'View Profile',
  'teachers.bookSession': 'Book Session',
  'teachers.filters.tajweed': 'Tajweed',
  'teachers.filters.hifz': 'Hifz',
  'teachers.filters.tafsir': 'Tafsir',
  'teachers.filters.arabic': 'Arabic Language',
  'teachers.filters.children': 'Children Education',
  'teachers.studentsTaught': 'students taught',
  'teachers.experience': 'Years Experience',
  'teachers.availability': 'Available',
  
  // ===========================================
  // Courses Page
  // ===========================================
  'courses.title': 'Our Educational Courses',
  'courses.subtitle': 'Discover our comprehensive collection of Quran and Arabic courses',
  'courses.search': 'Search for a course...',
  'courses.category': 'Category',
  'courses.level': 'Level',
  'courses.enrollNow': 'Enroll Now',
  'courses.learnMore': 'Learn More',
  'courses.duration': 'Duration',
  'courses.students': 'students enrolled',
  'courses.rating': 'Rating',
  'courses.price': 'Price',
  'courses.instructor': 'Instructor',
  'courses.categories.tajweed': 'Tajweed',
  'courses.categories.hifz': 'Hifz (Memorization)',
  'courses.categories.tafsir': 'Tafsir',
  'courses.categories.arabic': 'Arabic Language',
  'courses.categories.children': 'Children Courses',
  'courses.levels.beginner': 'Beginner',
  'courses.levels.intermediate': 'Intermediate',
  'courses.levels.advanced': 'Advanced',
  
  // ===========================================
  // About Page
  // ===========================================
  'about.title': 'About Hudan Lil Muttaqeen',
  'about.heroTitle': 'Our Mission: Making Quran Education Accessible to All',
  'about.heroSubtitle': 'Hudan Lil Muttaqeen connects students with the best Quran and Arabic teachers for a unique learning experience',
  'about.story.title': 'Our Story',
  'about.story.content': 'Our journey began with a simple goal: making high-quality Quran education accessible to Muslims everywhere. Today, we are proud to serve thousands of students from around the world.',
  'about.mission.title': 'Our Mission',
  'about.mission.content': 'To provide high-quality, accessible Islamic education to learners worldwide while preserving authenticity and scholarly traditions.',
  'about.vision.title': 'Our Vision',
  'about.vision.content': 'To become the leading global platform for online Quran and Arabic language education.',
  'about.values.title': 'Our Values',
  'about.values.excellence': 'Excellence & Mastery',
  'about.values.authenticity': 'Authenticity & Reliability',
  'about.values.accessibility': 'Accessibility',
  'about.values.community': 'Community Spirit',
  
  // ===========================================
  // Student Portal
  // ===========================================
  'studentPortal': 'Student Portal',
  'studentDashboard': 'Dashboard',
  'myCourses': 'My Courses',
  'mySchedule': 'My Schedule',
  'profile': 'Profile',
  'dashboard': 'Dashboard',
  'upcomingClasses': 'Upcoming Classes',
  'nextSevenDays': 'Next 7 days',
  'noUpcomingClasses': 'No upcoming classes scheduled',
  'enrolledCourses': 'Enrolled Courses',
  'yourCourses': 'Your courses',
  'noCoursesEnrolled': 'You are not enrolled in any courses yet',
  'progress': 'Progress',
  'learningProgress': 'Your learning progress',
  'recommendedTeachers': 'Recommended Teachers',
  'basedOnInterests': 'Based on your interests',
  'noRecommendations': 'No recommendations yet. Complete your profile to get personalized recommendations',
  'browseMoreCourses': 'Browse More Courses',
  'sampleCourseTitle': 'Introduction to Arabic',
  'sampleCourseTeacher': 'Teacher: Ahmad Al-Farsi',
  'sampleCourseDescription': 'Learn the basics of Arabic language including alphabet, pronunciation, and common phrases.',
  'continueStudying': 'Continue Studying',
  'calendar': 'Calendar',
  'selectDate': 'Select a date to view scheduled classes',
  'noDateSelected': 'No date selected',
  'scheduledClasses': 'Scheduled Classes',
  'noClassesScheduled': 'No classes scheduled for this date',
  'startLearning': 'Start Learning',
  'browse.teachers': 'Browse Teachers',
  'browseTeachers': 'Browse Teachers',
  'bookNewSession': 'Book New Session',
  'mySessions': 'My Sessions',
  'bookSession': 'Book Session',
  'selectConversation': 'Select a Conversation',
  'selectConversationDescription': 'Choose a conversation from the list to start messaging',
  'searchConversations': 'Search conversations',
  'typeMessage': 'Type a message…',
  'loadingMessages': 'Loading messages…',
  'noConversationsFound': 'No conversations found',
  'name': 'Name',
  'role': 'Role',
  'status': 'Status',
  'manageTeachers': 'Manage Teachers',
  'manageStudents': 'Manage Students',
  'personalInformation': 'Personal Information',
  'updateProfile': 'Update your profile information',
  'firstName': 'First Name',
  'lastName': 'Last Name',
  'email': 'Email',
  'emailChangeContact': 'To change your email, please contact support',
  'phone': 'Phone Number',
  'learningInterests': 'Learning Interests',
  'profileUpdated': 'Profile Updated',
  'profileUpdateSuccess': 'Your profile has been updated successfully',
  'saving': 'Saving...',
  'saveChanges': 'Save Changes',
  
  // ===========================================
  // Appearance Settings
  // ===========================================
  'appearance': 'Appearance',
  'appearanceSettings': 'Appearance Settings',
  'colors': 'Colors',
  'logoAndImages': 'Logo & Images',
  'typography': 'Typography',
  'settingsSaved': 'Settings Saved',
  'appearanceUpdated': 'Appearance settings have been updated successfully',
  'colorScheme': 'Color Scheme',
  'colorSchemeDescription': 'Customize the colors used throughout the application',
  'primaryColor': 'Primary Color',
  'secondaryColor': 'Secondary Color',
  'accentColor': 'Accent Color',
  'textColor': 'Text Color',
  'colorPreview': 'Color Preview',
  'primary': 'Primary',
  'secondary': 'Secondary',
  'accent': 'Accent',
  'text': 'Text',
  'logoDescription': 'Upload your logo and favicon',
  'mainLogo': 'Main Logo',
  'logoPreview': 'Logo Preview',
  'logoRequirements': 'Recommended size: 200x60px. Supported formats: PNG, SVG with transparent background.',
  'favicon': 'Favicon',
  'icon': 'Icon',
  'faviconRequirements': 'Recommended size: 32x32px. Supported formats: ICO, PNG.',
  'typographyDescription': 'Customize the fonts used throughout the application',
  'englishFont': 'English Font',
  'arabicFont': 'Arabic Font',
  'fontSampleEnglish': 'The quick brown fox jumps over the lazy dog.',
  'fontSampleArabic': 'هَذَا النَّصُّ هُوَ مِثَالٌ لِنَصٍّ يُمْكِنُ أَنْ يَسْتَبْدِلَ فِي نَفْس المَساحَة.',
  
  // ===========================================
  // Content Settings
  // ===========================================
  'content': 'Content',
  'contentSettings': 'Content Settings',
  'contentUpdated': 'Content settings have been updated successfully',
  'homepage': 'Homepage',
  'aboutPage': 'About Page',
  'aboutPageContent': 'About Page Content',
  'aboutPageDescription': 'Edit content for the about page',
  'seoSettings': 'SEO Settings',
  'homepageContent': 'Homepage Content',
  'homepageDescription': 'Edit content displayed on the homepage',
  'heroTitle': 'Hero Title',
  'defaultHeroTitle': 'Welcome to Hudan Lil Muttaqeen',
  'heroSubtitle': 'Hero Subtitle',
  'defaultHeroSubtitle': 'Learn with the best Quran and Arabic teachers from around the world',
  'heroImage': 'Hero Image',
  'ctaButtonText': 'CTA Button Text',
  'defaultCtaText': 'Start Learning',
  'featuredSections': 'Featured Sections',
  'section1Title': 'Section 1 Title',
  'defaultSection1Title': 'Learn Quran Online',
  'section1Content': 'Section 1 Content',
  'defaultSection1Content': 'Connect with qualified Quran teachers and learn Tajweed, Recitation, and Memorization at your own pace.',
  'section2Title': 'Section 2 Title',
  'defaultSection2Title': 'Master Arabic Language',
  'section2Content': 'Section 2 Content',
  'defaultSection2Content': 'Learn Modern Standard Arabic, Classical Arabic, and conversational skills with expert teachers.',
  'aboutTitle': 'About Title',
  'defaultAboutTitle': 'About Hudan Lil Muttaqeen',
  'aboutContent': 'About Content',
  'defaultAboutContent': 'Hudan Lil Muttaqeen is dedicated to connecting students with qualified teachers for Quran and Arabic language learning. Our mission is to make quality Islamic education accessible to everyone.',
  'aboutImage': 'About Image',
  'missionStatement': 'Mission Statement',
  'defaultMissionStatement': 'To provide accessible, high-quality Islamic education to learners worldwide.',
  'visionStatement': 'Vision Statement',
  'defaultVisionStatement': 'To become the leading platform for online Quran and Arabic language education.',
  'seoDescription': 'Configure SEO settings for better search visibility',
  'siteTitle': 'Site Title',
  'metaDescription': 'Meta Description',
  'defaultMetaDescription': 'Hudan Lil Muttaqeen connects students with qualified Quran and Arabic language teachers for personalized online learning.',
  'metaKeywords': 'Meta Keywords',
  'separateKeywords': 'Separate keywords with commas',
  'ogImage': 'Social Media Image',
  'ogImageDescription': 'This image will be shown when your site is shared on social media. Recommended size: 1200x630px.',
  
  // ===========================================
  // Control Panel
  // ===========================================
  'controlPanel': 'Control Panel',
  'backToDashboard': 'Back to Dashboard',
  
  // ===========================================
  // Payments
  // ===========================================
  'payments': 'Payments',
  'paymentSettings': 'Payment Settings',
  'paymentsUpdated': 'Payment settings have been updated successfully',
  'manualPayments': 'Manual Payments',
  'manualPaymentsDescription': 'Allow students to pay via bank transfer or other offline methods',
  'enableManualPayments': 'Enable Manual Payments',
  'enableManualPaymentsDescription': 'Students will be able to pay via bank transfer',
  'bankDetails': 'Bank Details',
  'bankDetailsPlaceholder': 'Enter your bank account details for manual transfers...',
  'paymentInstructions': 'Payment Instructions',
  'paymentInstructionsPlaceholder': 'Enter instructions for students on how to complete the payment...',
  'integration': 'Integration',
  'paypalDescription': 'Accept payments via PayPal',
  'enablePayPal': 'Enable PayPal',
  'enablePayPalDescription': 'Students will be able to pay via PayPal',
  'paypalClientId': 'PayPal Client ID',
  'paypalClientSecret': 'PayPal Client Secret',
  'testMode': 'Test Mode',
  'enableTestMode': 'Enable Test Mode',
  'testModeDescription': 'Use sandbox credentials for testing payments',
  'stripeDescription': 'Accept payments via Stripe',
  'enableStripe': 'Enable Stripe',
  'enableStripeDescription': 'Students will be able to pay via Stripe',
  'stripePublishableKey': 'Stripe Publishable Key',
  'stripeSecretKey': 'Stripe Secret Key',
  'stripeSecretKeyWarning': 'This key should be kept secure. It will be stored encrypted.',
  'stripeWebhookSecret': 'Stripe Webhook Secret',

  // ===========================================
  // Admin Dashboard
  // ===========================================
  'adminDashboard': 'Admin Dashboard',
  'totalStudents': 'Total Students',
  'totalTeachers': 'Total Teachers',
  'coursesOffered': 'Courses Offered',
  'monthlyRevenue': 'Monthly Revenue',
  'recentActivity': 'Recent Activity',
  'last30Days': 'Last 30 Days',
  'newStudentRegistered': 'New student registered',
  'daysAgo': 'days ago',
  'newCourseCreated': 'New course created',
  'paymentReceived': 'Payment received',
  'performanceMetrics': 'Performance Metrics',
  'chartsComingSoon': 'Charts and detailed analytics coming soon!',
  
  // ===========================================
  // Teacher Portal
  // ===========================================
  'teacherDashboard': 'Teacher Dashboard',
  'activeCourses': 'Active Courses',
  'todaySchedule': "Today's Schedule",
  'todayClasses': 'Classes for today',
  'noClassesToday': 'No classes scheduled for today',
  'recentMessages': 'Recent Messages',
  'fromStudents': 'From Students',
  'noMessages': 'No messages yet',
  'personalInfo': 'Personal Info',
  'professionalInfo': 'Professional Info',
  'qualifications': 'Qualifications',
  'location': 'Location',
  'professionalInformation': 'Professional Information',
  'teachingProfile': 'Teaching Profile',
  'biography': 'Biography',
  'sampleTeacherBio': 'I have been teaching Quranic Arabic for over 5 years, specializing in Tajweed and Memorization. My teaching methodology focuses on personalized learning paths for each student.',
  'teachingLanguages': 'Teaching Languages',
  'specialties': 'Specialties',
  'yearsOfExperience': 'Years of Experience',
  'hourlyRate': 'Hourly Rate',
  'certificationsEducation': 'Certifications & Education',
  'education': 'Education',
  'certifications': 'Certifications',
  'teachingMethodology': 'Teaching Methodology',
  'sampleTeachingMethodology': 'My approach combines traditional Quranic teaching methods with modern educational techniques, focusing on proper pronunciation, understanding, and memorization. I create a supportive environment for students of all levels.',
  'uploadDocuments': 'Upload Documents',
  'uploadDocumentsDescription': 'Upload degree certificates, teaching qualifications, and other relevant documents',
  'createCourse': 'Create Course',
  'studentsEnrolled': 'Students Enrolled',
  'draftStatus': 'Draft',
  'editCourse': 'Edit Course',
  'addAvailability': 'Add Availability',
  'setUpSchedule': 'Set Up Schedule',
  'myStudents': 'My Students',
  'searchStudents': 'Search students...',
  'studentsList': 'Students List',
  'viewManageStudents': 'View and manage your students',
  'noStudentsYet': 'No students enrolled yet',
  'inviteStudents': 'Invite Students',
  
  // ===========================================
  // Common / Misc
  // ===========================================
  'integrations': 'Integrations',
  'users': 'Users',
  'notifications': 'Notifications',
  'messages': 'Messages',
  'schedule': 'Schedule',
  'teacherPortal': 'Teacher Portal',
  'loading': 'Loading...',
  'error': 'An error occurred',
  'success': 'Success',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'delete': 'Delete',
  'edit': 'Edit',
  'save': 'Save',
  'submit': 'Submit',
  'back': 'Back',
  'next': 'Next',
  'previous': 'Previous',
  'search': 'Search',
  'filter': 'Filter',
  'sort': 'Sort',
  'all': 'All',
  'none': 'None',
  'yes': 'Yes',
  'no': 'No',

  // ===========================================
  // Marketing & Landing Page Content
  // ===========================================

  // Hero Section - Enhanced
  'hero.badge': 'Trusted Learning Platform',
  'hero.mainTitle': 'Your Journey to Master the Holy Quran Starts Here',
  'hero.cta.primary': 'Start Learning for Free',
  'hero.cta.secondary': 'Browse Teachers',
  'hero.stats.students': 'Active Students',
  'hero.stats.teachers': 'Qualified Teachers',
  'hero.stats.countries': 'Countries Worldwide',
  'hero.stats.satisfaction': 'Student Satisfaction',

  // Trust Badges
  'trust.certified': 'Teachers with Quran Ijazah certifications',
  'trust.secure': 'Secure & guaranteed payments',
  'trust.support': '24/7 customer support',
  'trust.guarantee': '7-day money-back guarantee',

  // Features Section - Enhanced
  'features.sectionTitle': 'Why Thousands Choose Hudan Lil Muttaqeen',
  'features.sectionSubtitle': 'A complete platform designed to make learning the Quran and Arabic an enjoyable and effective experience',

  'features.qualified.title': 'Qualified & Certified Teachers',
  'features.qualified.desc': 'All our teachers hold verified Quran Ijazah certifications and accredited teaching credentials, with a minimum of 3 years of experience',

  'features.flexible.title': 'Learn Anytime, Anywhere',
  'features.flexible.desc': 'Flexible class schedules that fit your time and lifestyle, accessible from any device and anywhere in the world',

  'features.interactive.title': 'Modern Interactive Lessons',
  'features.interactive.desc': 'Virtual classrooms equipped with the latest interactive tools for recitation, correction, and progress tracking',

  'features.tracking.title': 'Continuous Progress Tracking',
  'features.tracking.desc': 'Detailed progress reports and ongoing assessment of your level with a personalized learning plan',

  'features.personalized.title': 'A Curriculum Tailored to You',
  'features.personalized.desc': 'A learning program custom-designed around your level, goals, and pace of learning',

  'features.affordable.title': 'Affordable for Everyone',
  'features.affordable.desc': 'Diverse packages to suit every budget, with installment payment options available',

  // Courses Section - Enhanced
  'courses.sectionTitle': 'Our Featured Courses',
  'courses.sectionSubtitle': 'Comprehensive learning programs designed by experts in Quran and Arabic education',

  'courses.tajweed.title': 'Complete Tajweed Course',
  'courses.tajweed.desc': 'Learn the rules of Tajweed from scratch to mastery with practical application on verses of the Holy Quran',
  'courses.tajweed.duration': '24 training hours',
  'courses.tajweed.level': 'All levels',

  'courses.hifz.title': 'Quran Memorization Program',
  'courses.hifz.desc': 'A complete program for memorizing the Holy Quran with a structured methodology for memorization, review, and retention',
  'courses.hifz.duration': 'Based on memorization plan',
  'courses.hifz.level': 'All levels',

  'courses.arabic.title': 'Quranic Arabic Language',
  'courses.arabic.desc': 'Learn Arabic through the Holy Quran — grammar, morphology, rhetoric, and the meanings of words',
  'courses.arabic.duration': '36 training hours',
  'courses.arabic.level': 'Intermediate & Advanced',

  'courses.kids.title': 'Quran for Kids',
  'courses.kids.desc': 'A fun and engaging educational program for children aged 5+ with interactive teaching methods',
  'courses.kids.duration': '30-minute sessions',
  'courses.kids.level': 'For kids ages 5-12',

  // Testimonials - Enhanced
  'testimonials.sectionTitle': 'What Our Students Say About Us',
  'testimonials.sectionSubtitle': 'Thousands of students from around the world share their experience with Hudan Lil Muttaqeen',

  'testimonials.1.text': 'By the grace of Allah and then this platform, my son was able to memorize 5 juz in less than a year. The teacher is excellent and the curriculum is wonderful.',
  'testimonials.1.name': 'Umm Muhammad',
  'testimonials.1.location': 'United States',
  'testimonials.1.role': 'Mother of two',

  'testimonials.2.text': 'I had been searching for a female Quran teacher for my daughters for a while. At Hudan Lil Muttaqeen I found qualified, hijab-observing female teachers. May Allah reward them.',
  'testimonials.2.name': 'Fatima Ahmed',
  'testimonials.2.location': 'United Kingdom',
  'testimonials.2.role': 'Tajweed Student',

  'testimonials.3.text': 'I am a new Muslim and I did not know how to read the Quran. Now, after 6 months, I read fluently, alhamdulillah. The platform is very easy to use.',
  'testimonials.3.name': 'Abdullah Johnson',
  'testimonials.3.location': 'Canada',
  'testimonials.3.role': 'New Muslim',

  'testimonials.4.text': 'As a Quran teacher, I find everything I need on this platform. The management is excellent, the students are serious, and payments are always on time.',
  'testimonials.4.name': 'Sheikh Ahmed Al-Husseini',
  'testimonials.4.location': 'Egypt',
  'testimonials.4.role': 'Quran & Tajweed Teacher',

  // CTA Section - Enhanced
  'cta.feature1': 'Free trial session',
  'cta.feature2': 'Money-back guarantee',
  'cta.feature3': 'Ongoing customer support',
  'cta.button.student': 'Register as a Student',
  'cta.button.teacher': 'Join as a Teacher',

  // FAQ Section
  'faq.sectionTitle': 'Frequently Asked Questions',
  'faq.sectionSubtitle': 'Answers to the most common questions our students ask',

  'faq.q1': 'How do I get started on the platform?',
  'faq.a1': 'Simply create a free account, browse our teachers and choose the right one for you, then book your first session. We offer a free trial session to all new students.',

  'faq.q2': 'What are the qualifications of teachers on the platform?',
  'faq.a2': 'All our teachers hold Ijazah certifications in the Holy Quran from certified scholars and have at least 3 years of teaching experience. We verify all certifications before accepting any teacher.',

  'faq.q3': 'Do you offer classes for children?',
  'faq.a3': 'Yes, we have programs designed for children ages 5 and up, with teachers who specialize in teaching children through interactive and enjoyable methods suited to their age.',

  'faq.q4': 'What payment methods are available?',
  'faq.a4': 'We accept all major credit cards, PayPal, bank transfer, and some local payment methods. All transactions are encrypted and secure.',

  'faq.q5': 'Can I change my teacher?',
  'faq.a5': 'Absolutely! You can change your teacher at any time if you are not comfortable. We want you to find the perfect teacher for you.',

  'faq.q6': 'What is the cancellation policy?',
  'faq.a6': 'You can cancel or reschedule any session at least 24 hours in advance at no charge. We also offer a 7-day money-back guarantee.',

  // Social Proof
  'social.studentsCount': '10,000+',
  'social.studentsLabel': 'Students Worldwide',
  'social.teachersCount': '200+',
  'social.teachersLabel': 'Qualified Teachers',
  'social.countriesCount': '50+',
  'social.countriesLabel': 'Countries',
  'social.rating': '4.9/5',
  'social.ratingLabel': 'Student Rating',

  // Value Propositions
  'value.free.title': 'Free Trial Session',
  'value.free.desc': 'Try the platform for free before subscribing',
  'value.guarantee.title': 'Satisfaction Guarantee',
  'value.guarantee.desc': 'Full refund within 7 days',
  'value.support.title': 'Ongoing Support',
  'value.support.desc': 'A support team always available to help you',

  // Process Steps
  'process.title': 'How Do You Start Your Journey With Us?',
  'process.subtitle': '4 simple steps stand between you and learning the Quran',

  'process.step1.title': 'Create Your Account',
  'process.step1.desc': 'Register for free in one minute and complete your profile',

  'process.step2.title': 'Choose Your Teacher',
  'process.step2.desc': 'Browse teacher profiles and pick the best fit for you and your goals',

  'process.step3.title': 'Book Your Session',
  'process.step3.desc': 'Pick a convenient time and book your first free session',

  'process.step4.title': 'Start Learning',
  'process.step4.desc': 'Join the virtual classroom and begin your journey to Quran mastery',

  // Urgency & Scarcity
  'urgency.limitedSpots': 'Limited spots available!',
  'urgency.spotsLeft': 'Only {count} seats left this month',
  'urgency.offer': 'Special offer: 20% off the monthly package',
  'urgency.offerEnds': 'Offer ends in',

  // For Teachers Page
  'forTeachers.title': 'Join Our Team of Teachers',
  'forTeachers.subtitle': 'Share your knowledge and serve the Ummah through Hudan Lil Muttaqeen',

  'forTeachers.benefit1.title': 'Steady Income',
  'forTeachers.benefit1.desc': 'Earn a consistent monthly income with the flexibility to set your own rates and schedule',

  'forTeachers.benefit2.title': 'Students From Around the World',
  'forTeachers.benefit2.desc': 'Connect with serious students from more than 50 countries',

  'forTeachers.benefit3.title': 'Professional Tools',
  'forTeachers.benefit3.desc': 'An integrated platform for managing students, schedule, and payments',

  'forTeachers.benefit4.title': 'Continuous Support',
  'forTeachers.benefit4.desc': 'A dedicated team to support you every step of the way',

  'forTeachers.cta': 'Apply to Join',
  'forTeachers.requirements': 'Requirements: Quran Ijazah + at least 3 years of teaching experience',

  // ===========================================
  // Auth — Login Page
  // ===========================================
  'auth.login.success.title': 'Login successful',
  'auth.login.success.desc': 'Welcome back!',
  'auth.login.error.title': 'Login failed',
  'auth.login.error.credentials': 'Please check your credentials.',
  'auth.login.error.generic': 'An error occurred. Please try again.',
  'auth.login.heading': 'Welcome Back',
  'auth.login.subheading': 'Sign in to your Hudan Lil Muttaqeen account',
  'auth.login.email.placeholder': 'Enter your email',
  'auth.login.password.label': 'Password',
  'auth.login.password.placeholder': 'Enter your password',
  'auth.login.password.show': 'Show password',
  'auth.login.password.hide': 'Hide password',
  'auth.login.forgotPassword': 'Forgot password?',
  'auth.login.signingIn': 'Signing in...',
  'auth.login.submit': 'Sign In',
  'auth.login.noAccount': "Don't have an account? ",
  'auth.login.register': 'Register',

  // ===========================================
  // Auth — Register Page
  // ===========================================
  'auth.register.heading': 'Join Our Learning Community',
  'auth.register.subheading': 'Create an account to start your journey with Hudan Lil Muttaqeen',
  'auth.register.asStudent': 'Register as Student',
  'auth.register.studentDesc': "Find a teacher and start your Qur'anic learning journey",
  'auth.register.studentBenefit1': 'Find qualified teachers',
  'auth.register.studentBenefit2': 'Flexible learning times',
  'auth.register.studentBenefit3': 'Track your progress',
  'auth.register.studentBenefit4': 'Manage payments',
  'auth.register.asTeacher': 'Register as Teacher',
  'auth.register.teacherDesc': 'Share your knowledge and connect with students',
  'auth.register.teacherBenefit1': 'Create your profile',
  'auth.register.teacherBenefit2': 'Set your schedule',
  'auth.register.teacherBenefit3': 'Define your rates',
  'auth.register.teacherBenefit4': 'Secure monthly payments',
  'auth.register.asParent': 'Register as Parent',
  'auth.register.parentDesc': 'Enrol your children and follow their progress from one account',
  'auth.register.parentBenefit1': 'Add each of your children',
  'auth.register.parentBenefit2': 'Choose a teacher for every child',
  'auth.register.parentBenefit3': 'Follow their memorisation',
  'auth.register.parentBenefit4': 'One account, one bill',
  'auth.register.haveAccount': 'Already have an account? ',
  'auth.register.signIn': 'Sign in here',

  // ===========================================
  // Auth — Parent Registration Form
  // ===========================================
  'auth.parent.title': 'Parent Registration',
  'auth.parent.description': 'Create a family account, then add your children and choose their teachers.',
  'auth.parent.firstName': 'First Name',
  'auth.parent.lastName': 'Last Name',
  'auth.parent.fullNameAr': 'Full Name (Arabic)',
  'auth.parent.fullNameArOptional': 'Full Name in Arabic (optional)',
  'auth.parent.email': 'Email',
  'auth.parent.phone': 'Phone',
  'auth.parent.phoneOptional': 'Phone (optional)',
  'auth.parent.password': 'Password',
  'auth.parent.confirmPassword': 'Confirm Password',
  'auth.parent.submit': 'Create Family Account',
  'auth.parent.submitting': 'Creating account…',
  'auth.parent.terms': 'I agree to the Terms of Service and Privacy Policy',
  'auth.parent.termsRequired': 'Please accept the terms',
  'auth.parent.termsRequiredDesc': 'You must agree to the Terms of Service to continue.',
  'auth.parent.passwordMismatch': 'Passwords do not match',
  'auth.parent.passwordMismatchDesc': 'Please make sure both passwords are identical.',
  'auth.parent.passwordTooShort': 'Password is too short',
  'auth.parent.passwordTooShortDesc': 'Please use at least 8 characters.',
  'auth.parent.success': 'Family account created',
  'auth.parent.successDesc': 'You can now add your children and choose their teachers.',
  'auth.parent.verifyDesc': 'Please check your email to verify your account, then sign in.',
  'auth.parent.failed': 'Registration failed',
  'auth.parent.childrenNote': 'Your children do not need their own email address or password — you manage everything from your account.',
  'auth.parent.haveAccount': 'Already have an account? ',
  'auth.parent.signIn': 'Sign in',

  // ===========================================
  // Teacher Profile Page
  // ===========================================
  'teacherProfile.notFound.title': 'Teacher not found',
  'teacherProfile.notFound.desc': "We couldn't find this teacher",
  'teacherProfile.quranTeacherTitle': 'Quran Teacher',
  'teacherProfile.certifiedQuranTeacher': 'Certified Quran teacher',
  'teacherProfile.backToTeachers': 'Back to Teachers',
  'teacherProfile.yearsExp': 'years exp.',
  'teacherProfile.yearsExperience': 'years experience',
  'teacherProfile.loginToBook': 'Login to Book',
  'teacherProfile.signupToBook': 'Sign up to Book',
  'teacherProfile.sendMessage': 'Send Message',
  'teacherProfile.students': 'students',
  'teacherProfile.sessions': 'sessions',
  'teacherProfile.sessionsCompleted': 'sessions completed',
  'teacherProfile.hr': 'hr',
  'teacherProfile.about': 'About',
  'teacherProfile.noBio': 'No bio available',
  'teacherProfile.watchVideo': 'Watch Intro Video',
  'teacherProfile.notSpecified': 'Not specified',
  'teacherProfile.lessons': 'lessons',
  'teacherProfile.free': 'Free',
  'teacherProfile.reviews': 'Reviews',
  'teacherProfile.reviewsCount': 'reviews',
  'teacherProfile.noReviews': 'No reviews yet',
  'teacherProfile.trialAvailable': 'Trial session available',
  'teacherProfile.availability': 'Availability',
  'teacherProfile.quickInfo': 'Quick Info',
  'teacherProfile.ijazahCertified': 'Ijazah Certified Teacher',
  'teacherProfile.teacherResponse': 'Teacher Response',
  'teacherProfile.outOfStars': 'out of 5 stars',
  'teacherProfile.ratingAriaLabel': '{rating} out of 5 stars',
  'teacherProfile.ratingReviewsAriaLabel': '{rating} out of 5 stars, {count} reviews',
  'teacherProfile.averageRatingAriaLabel': 'Average {rating} out of 5 stars',

  // ===========================================
  // Booking Flow (Student)
  // ===========================================
  'booking.title': 'Book a Session',
  'booking.with': 'with',
  'booking.toast.success': 'Booking request sent successfully!',
  'booking.toast.failed': 'Failed to submit booking',
  'booking.steps.date': 'Select Date',
  'booking.steps.time': 'Pick Time',
  'booking.steps.details': 'Session Details',
  'booking.steps.confirm': 'Confirm',
  'booking.selectDate.title': 'Select Session Date',
  'booking.selectDate.desc': 'Choose an available day from the calendar',
  'booking.pickTime.title': 'Pick Session Time',
  'booking.details.title': 'Session Details',
  'booking.sessionType': 'Session Type',
  'booking.type.trial': 'Trial',
  'booking.type.trialDesc': '30 min - Free',
  'booking.type.regular': 'Regular',
  'booking.type.regularDesc60': '60 min',
  'booking.type.trialPriceLabel': 'Trial - Free',
  'booking.duration': 'Duration',
  'booking.minutes': 'min',
  'booking.messageLabel': 'Message to Teacher (optional)',
  'booking.messagePlaceholder': 'Tell the teacher about your goals or any special requests...',
  'booking.confirmTitle': 'Confirm Booking',
  'booking.confirmDesc': 'Review your booking details before submitting',
  'booking.teacher': 'Teacher',
  'booking.date': 'Date',
  'booking.time': 'Time',
  'booking.typeAndPrice': 'Type & Price',
  'booking.yourMessage': 'Your Message',
  'booking.approvalNotice': "Your booking request will be sent to the teacher for approval. You'll receive a notification once accepted.",
  'booking.back': 'Back',

  // ===========================================
  // Teacher Media Library
  // ===========================================
  'teacher.media.title': 'Media Library',
  'teacher.media.itemsInLibrary': 'items in your library',
  'teacher.media.uploadNew': 'Upload Media',
  'teacher.media.search.placeholder': 'Search library...',
  'teacher.media.filter.type': 'Type',
  'teacher.media.filter.allTypes': 'All Types',
  'teacher.media.filter.status': 'Status',
  'teacher.media.filter.all': 'All',
  'teacher.media.type.audio': 'Audio',
  'teacher.media.type.video': 'Video',
  'teacher.media.status.draft': 'Draft',
  'teacher.media.status.published': 'Published',
  'teacher.media.status.unlisted': 'Unlisted',
  'teacher.media.status.archived': 'Archived',
  'teacher.media.stats.audioFiles': 'Audio Files',
  'teacher.media.stats.videoFiles': 'Video Files',
  'teacher.media.stats.totalViews': 'Total Views',
  'teacher.media.stats.totalLikes': 'Total Likes',
  'teacher.media.empty.title': 'No media yet',
  'teacher.media.empty.subtitle': 'Start by uploading your first audio or video file',
  'teacher.media.empty.upload': 'Upload Media',
  'teacher.media.pagination.previous': 'Previous',
  'teacher.media.pagination.next': 'Next',
  'teacher.media.action.edit': 'Edit',
  'teacher.media.action.publish': 'Publish',
  'teacher.media.action.delete': 'Delete',
  'teacher.media.action.cancel': 'Cancel',
  'teacher.media.action.upload': 'Upload',
  'teacher.media.action.uploading': 'Uploading...',
  'teacher.media.action.saveChanges': 'Save Changes',
  'teacher.media.toast.published': 'Published',
  'teacher.media.toast.deleted': 'Deleted',
  'teacher.media.toast.uploaded': 'Media uploaded successfully',
  'teacher.media.toast.uploadFailed': 'Upload failed',
  'teacher.media.toast.updated': 'Updated successfully',
  'teacher.media.toast.updateFailed': 'Update failed',
  'teacher.media.confirm.delete': 'Are you sure you want to delete this?',
  'teacher.media.error.titleRequired': 'Title is required',
  'teacher.media.error.fileOrUrl': 'Please upload a file or enter an external URL',
  'teacher.media.upload.dialogTitle': 'Upload New Media',
  'teacher.media.upload.clickToUploadFile': 'Click to upload file',
  'teacher.media.upload.clickToUploadThumbnail': 'Click to upload thumbnail',
  'teacher.media.edit.dialogTitle': 'Edit Media',
  'teacher.media.field.titleEn': 'Title (English)',
  'teacher.media.field.titleEnRequired': 'Title (English) *',
  'teacher.media.field.titleEnPlaceholder': 'Enter title in English',
  'teacher.media.field.titleAr': 'Title (Arabic)',
  'teacher.media.field.titleArPlaceholder': 'Enter title in Arabic',
  'teacher.media.field.mediaType': 'Media Type',
  'teacher.media.field.visibility': 'Visibility',
  'teacher.media.field.status': 'Status',
  'teacher.media.field.mediaFileRequired': 'Media File *',
  'teacher.media.field.externalUrl': 'Or External URL',
  'teacher.media.field.externalUrlPlaceholder': 'YouTube URL or external link',
  'teacher.media.field.thumbnail': 'Thumbnail',
  'teacher.media.field.duration': 'Duration (seconds)',
  'teacher.media.field.descriptionEn': 'Description (English)',
  'teacher.media.field.descriptionAr': 'Description (Arabic)',
  'teacher.media.field.seoKeywords': 'SEO Keywords',
  'teacher.media.field.seoKeywordsPlaceholder': 'Comma-separated keywords',
  'teacher.media.field.tags': 'Tags',
  'teacher.media.visibility.public': 'Public',
  'teacher.media.visibility.loginRequired': 'Login Required',
  'teacher.media.visibility.private': 'Private',

  // Teacher Courses (create/edit)
  'teacher.courses.subtitle': 'Create and manage your courses',
  'teacher.courses.empty.title': 'No courses yet',
  'teacher.courses.empty.description': 'Create your first course to start teaching students on the platform.',
  'teacher.courses.create.dialogTitle': 'Create Course',
  'teacher.courses.edit.dialogTitle': 'Edit Course',
  'teacher.courses.field.titleEnRequired': 'Title (English) *',
  'teacher.courses.field.titleEnPlaceholder': 'Enter course title in English',
  'teacher.courses.field.titleAr': 'Title (Arabic)',
  'teacher.courses.field.titleArPlaceholder': 'Enter course title in Arabic',
  'teacher.courses.field.category': 'Category',
  'teacher.courses.field.level': 'Level',
  'teacher.courses.field.shortDescEn': 'Short Description (English)',
  'teacher.courses.field.shortDescAr': 'Short Description (Arabic)',
  'teacher.courses.field.descEn': 'Description (English)',
  'teacher.courses.field.descAr': 'Description (Arabic)',
  'teacher.courses.field.thumbnail': 'Thumbnail',
  'teacher.courses.field.clickToUploadThumbnail': 'Click to upload thumbnail',
  'teacher.courses.field.free': 'Free course',
  'teacher.courses.field.price': 'Price (USD)',
  'teacher.courses.action.create': 'Create',
  'teacher.courses.action.saveChanges': 'Save Changes',
  'teacher.courses.action.saving': 'Saving...',
  'teacher.courses.toast.created': 'Course created as a draft. It will be visible after admin review.',
  'teacher.courses.toast.updated': 'Course updated successfully',
  'teacher.courses.toast.saveFailed': 'Failed to save course',
  'teacher.courses.toast.uploadFailed': 'Thumbnail upload failed',
  'teacher.courses.error.titleRequired': 'Title (English) is required',
  'teacher.courses.status.draft': 'Draft',
  'teacher.courses.status.pendingReview': 'Pending Review',
  'teacher.courses.status.published': 'Published',
  'teacher.courses.status.archived': 'Archived',
  'teacher.courses.category.quran': 'Quran',
  'teacher.courses.category.tajweed': 'Tajweed',
  'teacher.courses.category.memorization': 'Memorization',
  'teacher.courses.category.arabicLanguage': 'Arabic Language',
  'teacher.courses.category.islamicStudies': 'Islamic Studies',
  'teacher.courses.category.quranicArabic': 'Quranic Arabic',
  'teacher.courses.category.tafseer': 'Tafseer',
  'teacher.courses.category.other': 'Other',
  'teacher.courses.level.beginner': 'Beginner',
  'teacher.courses.level.intermediate': 'Intermediate',
  'teacher.courses.level.advanced': 'Advanced',
  'teacher.courses.level.allLevels': 'All Levels',

  // Cookie Consent Banner (P7.4.3)
  'cookies.title': 'We value your privacy',
  'cookies.message': 'We use cookies to improve your experience and analyse site usage. Essential cookies are always on. You can choose which other categories to allow.',
  'cookies.acceptAll': 'Accept all',
  'cookies.rejectNonEssential': 'Reject non-essential',
  'cookies.customize': 'Customize',
  'cookies.save': 'Save preferences',
  'cookies.essential': 'Essential',
  'cookies.essentialDesc': 'Required for the site to function. Cannot be disabled.',
  'cookies.analytics': 'Analytics',
  'cookies.analyticsDesc': 'Help us understand how visitors interact with the site.',
  'cookies.marketing': 'Marketing',
  'cookies.marketingDesc': 'Used to deliver relevant ads and track campaign performance.',
  'cookies.privacyPolicyLink': 'Privacy Policy',

  // Admin Dashboard (P3.1.2 batch 4)
  'admin.dashboard.subtitle': 'Platform overview and management',
  'admin.dashboard.stat.sessions': 'Sessions',
  'admin.dashboard.stat.revenue': 'Revenue',
  'admin.dashboard.stat.completed': 'completed',
  'admin.dashboard.stat.pending': 'pending',
  'admin.dashboard.stat.commission': 'Commission:',
  'admin.dashboard.secondary.pendingApprovals': 'Pending Approvals',
  'admin.dashboard.secondary.reviewApplications': 'Review applications',
  'admin.dashboard.secondary.pendingPayments': 'Pending Payments',
  'admin.dashboard.secondary.verifyPayments': 'Verify payments',
  'admin.dashboard.secondary.totalTeachers': 'Total Teachers',
  'admin.dashboard.secondary.manageTeachers': 'Manage teachers',
  'admin.dashboard.pending.title': 'Pending Applications',
  'admin.dashboard.pending.desc': 'Teachers awaiting approval',
  'admin.dashboard.pending.noSpecialty': 'No specialty specified',
  'admin.dashboard.pending.review': 'Review',
  'admin.dashboard.pending.viewAll': 'View All',
  'admin.dashboard.pending.empty': 'No pending applications',
  'admin.dashboard.revenue.title': 'Revenue Overview',
  'admin.dashboard.revenue.last30days': 'Last 30 days',
  'admin.dashboard.revenue.totalRevenue': 'Total Revenue',
  'admin.dashboard.revenue.platformCommission': 'Platform Commission',
  'admin.dashboard.revenue.teacherPayouts': 'Teacher Payouts',
  'admin.dashboard.revenue.sessionsCount': 'Sessions Count',
  'admin.dashboard.revenue.detailedReport': 'Detailed Report',
  'admin.dashboard.revenue.noData': 'No data available',
  'admin.dashboard.quickActions.title': 'Quick Actions',
  'admin.dashboard.quickActions.finance': 'Finance',
  'admin.dashboard.quickActions.analytics': 'Analytics',
  'admin.dashboard.quickActions.institutions': 'Institutions',
  'admin.dashboard.quickActions.cms': 'CMS',

  // Admin Refunds (P3.1.2 batch 4)
  'admin.refunds.toast.approved': 'Refund approved',
  'admin.refunds.toast.processed': 'Refund processed',
  'admin.refunds.toast.rejected': 'Refund rejected',
  'admin.refunds.title': 'Refund Management',
  'admin.refunds.subtitle': 'Review and process refund requests',
  'admin.refunds.stat.total': 'Total',
  'admin.refunds.stat.pending': 'Pending',
  'admin.refunds.stat.completed': 'Completed',
  'admin.refunds.stat.totalRefunded': 'Total Refunded',
  'admin.refunds.filter.allStatus': 'All Status',
  'admin.refunds.filter.approved': 'Approved',
  'admin.refunds.filter.rejected': 'Rejected',
  'admin.refunds.col.ref': 'Ref',
  'admin.refunds.col.student': 'Student',
  'admin.refunds.col.teacher': 'Teacher',
  'admin.refunds.col.amount': 'Amount',
  'admin.refunds.col.reason': 'Reason',
  'admin.refunds.col.status': 'Status',
  'admin.refunds.col.date': 'Date',
  'admin.refunds.col.actions': 'Actions',
  'admin.refunds.action.approve': 'Approve',
  'admin.refunds.action.reject': 'Reject',
  'admin.refunds.action.process': 'Process',
  'admin.refunds.empty.title': 'No refunds found',
  'admin.refunds.empty.desc': 'No refund requests at this time',
  'admin.refunds.dialog.approve': 'Approve Refund',
  'admin.refunds.dialog.process': 'Process Refund',
  'admin.refunds.dialog.reject': 'Reject Refund',
  'admin.refunds.dialog.reasonPlaceholder': 'Reason for rejection...',

  // Admin Finance (P3.1.2 batch 4)
  'admin.finance.stat.totalRevenue': 'Total Revenue',
  'admin.finance.stat.netProfit': 'Net Profit',
  'admin.finance.stat.transactions': 'Transactions',
  'admin.finance.stat.avgValue': 'Avg. Value',
  'admin.finance.title': 'Financial Management',
  'admin.finance.subtitle': 'Revenue, transactions, and payments',
  'admin.finance.refunds': 'Refunds',
  'admin.finance.scholarships': 'Scholarships',
  'admin.finance.period.week': 'Week',
  'admin.finance.period.month': 'Month',
  'admin.finance.period.quarter': 'Quarter',
  'admin.finance.period.year': 'Year',
  'admin.finance.vsPrev': 'vs previous period',
  'admin.finance.recentTransactions': 'Recent Transactions',
  'admin.finance.filter.allStatus': 'All Status',
  'admin.finance.filter.completed': 'Completed',
  'admin.finance.filter.pending': 'Pending',
  'admin.finance.filter.failed': 'Failed',
  'admin.finance.filter.refunded': 'Refunded',
  'admin.finance.col.reference': 'Reference',
  'admin.finance.col.student': 'Student',
  'admin.finance.col.amount': 'Amount',
  'admin.finance.col.method': 'Method',
  'admin.finance.col.status': 'Status',
  'admin.finance.col.date': 'Date',

  // Teacher Schedule (P3.1.2 batch 5)
  'teacher.schedule.subtitle': 'Manage your sessions and availability',
  'teacher.schedule.daysWithSessions': 'Days with sessions',
  'teacher.schedule.sessionsCount': 'session(s)',
  'teacher.schedule.minutes': 'min',
  'teacher.schedule.toast.savedTitle': 'Saved',
  'teacher.schedule.toast.savedDesc': 'Availability schedule updated successfully',
  'teacher.schedule.toast.saveFailed': 'Failed to save availability',
  'teacher.schedule.toast.completedTitle': 'Session Completed',
  'teacher.schedule.toast.completedDesc': 'Session marked as completed',
  'teacher.schedule.toast.completeFailed': 'Failed to complete session',
  'teacher.schedule.toast.cancelledTitle': 'Session Cancelled',
  'teacher.schedule.toast.cancelledDesc': 'Session cancelled successfully',
  'teacher.schedule.toast.cancelFailed': 'Failed to cancel session',
  'teacher.schedule.toast.updatedTitle': 'Updated',
  'teacher.schedule.toast.updatedDesc': 'Session updated successfully',
  'teacher.schedule.toast.updateFailed': 'Failed to update session',
  'teacher.schedule.status.scheduled': 'Scheduled',
  'teacher.schedule.status.inProgress': 'In Progress',
  'teacher.schedule.status.completed': 'Completed',
  'teacher.schedule.status.cancelled': 'Cancelled',
  'teacher.schedule.status.noShow': 'No Show',
  'teacher.schedule.action.start': 'Start',
  'teacher.schedule.action.complete': 'Complete',
  'teacher.schedule.action.addSlot': 'Add Time Slot',
  'teacher.schedule.action.saving': 'Saving...',
  'teacher.schedule.action.saveChanges': 'Save Changes',
  'teacher.schedule.action.goBack': 'Go Back',
  'teacher.schedule.action.cancelling': 'Cancelling...',
  'teacher.schedule.action.confirmCancel': 'Confirm Cancellation',
  'teacher.schedule.dialog.manageAvailability': 'Manage Availability',
  'teacher.schedule.dialog.manageAvailabilityDesc': 'Set your weekly availability schedule',
  'teacher.schedule.dialog.editSession': 'Edit Session',
  'teacher.schedule.dialog.cancelSession': 'Cancel Session',
  'teacher.schedule.dialog.cancelSessionDesc': 'Are you sure you want to cancel this session? The student will be notified.',
  'teacher.schedule.empty.noSlots': 'No availability slots set',
  'teacher.schedule.day.monday': 'Monday',
  'teacher.schedule.day.tuesday': 'Tuesday',
  'teacher.schedule.day.wednesday': 'Wednesday',
  'teacher.schedule.day.thursday': 'Thursday',
  'teacher.schedule.day.friday': 'Friday',
  'teacher.schedule.day.saturday': 'Saturday',
  'teacher.schedule.day.sunday': 'Sunday',
  'teacher.schedule.field.meetingLink': 'Meeting Link',
  'teacher.schedule.field.notes': 'Notes',
  'teacher.schedule.placeholder.notes': 'Notes for the student...',
  'teacher.schedule.placeholder.cancelReason': 'Reason for cancellation...',

  // Admin Scholarships (P3.1.2 batch 5)
  'admin.scholarships.toast.updated': 'Scholarship updated',
  'admin.scholarships.toast.error': 'An error occurred',
  'admin.scholarships.title': 'Scholarship Management',
  'admin.scholarships.subtitle': 'Review and manage scholarship applications',
  'admin.scholarships.stat.total': 'Total',
  'admin.scholarships.stat.pending': 'Pending',
  'admin.scholarships.stat.approved': 'Approved',
  'admin.scholarships.stat.totalAmount': 'Total Amount',
  'admin.scholarships.filter.allStatus': 'All Status',
  'admin.scholarships.filter.pending': 'Pending',
  'admin.scholarships.filter.underReview': 'Under Review',
  'admin.scholarships.filter.approved': 'Approved',
  'admin.scholarships.filter.rejected': 'Rejected',
  'admin.scholarships.type.needBased': 'Need Based',
  'admin.scholarships.type.meritBased': 'Merit Based',
  'admin.scholarships.type.hafiz': 'Hafiz',
  'admin.scholarships.type.community': 'Community',
  'admin.scholarships.type.full': 'Full',
  'admin.scholarships.action.approve': 'Approve',
  'admin.scholarships.action.reject': 'Reject',
  'admin.scholarships.empty.title': 'No scholarships found',
  'admin.scholarships.empty.desc': 'No scholarship applications at this time',
  'admin.scholarships.dialog.approveTitle': 'Approve Scholarship',
  'admin.scholarships.dialog.rejectTitle': 'Reject Scholarship',
  'admin.scholarships.field.amount': 'Amount ($)',
  'admin.scholarships.field.notes': 'Notes',
  'admin.scholarships.placeholder.rejectReason': 'Reason for rejection...',
  'admin.scholarships.placeholder.reviewNotes': 'Review notes...',

  // Admin Analytics (P3.1.2 batch 5)
  'admin.analytics.title': 'Platform Analytics',
  'admin.analytics.subtitle': 'Comprehensive insights into platform performance',
  'admin.analytics.period.week': 'Week',
  'admin.analytics.period.month': 'Month',
  'admin.analytics.period.year': 'Year',
  'admin.analytics.tab.overview': 'Overview',
  'admin.analytics.tab.revenue': 'Revenue',
  'admin.analytics.tab.sessions': 'Sessions',
  'admin.analytics.tab.teachers': 'Teachers',
  'admin.analytics.tab.hifz': 'Hifz',
  'admin.analytics.teachers.title': 'Teacher Utilization',
  'admin.analytics.teachers.active': 'Active Teachers',
  'admin.analytics.teachers.avgUtilization': 'Avg. Utilization',
  'admin.analytics.teachers.sessions': 'sessions',

  // P3.1.2 batch 6 — TeacherEarnings
  'teacherEarnings.title': 'Earnings & Payouts',
  'teacherEarnings.subtitle': 'Track your revenue and payouts',
  'teacherEarnings.period.week': 'This Week',
  'teacherEarnings.period.month': 'This Month',
  'teacherEarnings.period.year': 'This Year',
  'teacherEarnings.period.allTime': 'All Time',
  'teacherEarnings.stats.totalEarnings': 'Total Earnings',
  'teacherEarnings.stats.netIncome': 'Net Income',
  'teacherEarnings.stats.sessionsCompleted': 'Sessions Completed',
  'teacherEarnings.stats.pendingPayout': 'Pending Payout',
  'teacherEarnings.breakdown.title': 'Revenue Breakdown',
  'teacherEarnings.breakdown.subtitle': 'Income sources',
  'teacherEarnings.breakdown.individual': 'Individual Sessions',
  'teacherEarnings.breakdown.packages': 'Package Sessions',
  'teacherEarnings.breakdown.group': 'Group Sessions',
  'teacherEarnings.breakdown.commission': 'Platform Commission',
  'teacherEarnings.payouts.title': 'Recent Payouts',
  'teacherEarnings.payouts.subtitle': 'Payout history',
  'teacherEarnings.payouts.empty.title': 'No payouts yet',
  'teacherEarnings.payouts.empty.desc': 'Your payouts will appear here',
  'teacherEarnings.avgPerHour.label': 'Average Earnings Per Hour',
  'teacherEarnings.avgPerHour.note': 'After commission deduction',

  // P3.1.2 batch 6 — StudentCourses (sessions page)
  'studentCourses.subtitle': 'View and manage your sessions',
  'studentCourses.status.scheduled': 'Scheduled',
  'studentCourses.status.inProgress': 'In Progress',
  'studentCourses.status.completed': 'Completed',
  'studentCourses.status.cancelled': 'Cancelled',
  'studentCourses.status.noShow': 'No Show',
  'studentCourses.tabs.upcoming': 'Upcoming',
  'studentCourses.tabs.completed': 'Completed',
  'studentCourses.tabs.all': 'All',
  'studentCourses.duration.min': 'min',
  'studentCourses.action.join': 'Join',
  'studentCourses.action.rate': 'Rate',
  'studentCourses.empty.upcoming': 'No upcoming sessions',
  'studentCourses.empty.completed': 'No completed sessions yet',
  'studentCourses.empty.all': 'No sessions yet',
  'studentCourses.rating.title': 'Rate Your Session',
  'studentCourses.rating.description': 'How was your experience with this session?',
  'studentCourses.rating.select': 'Select your rating',
  'studentCourses.rating.excellent': 'Excellent!',
  'studentCourses.rating.veryGood': 'Very Good',
  'studentCourses.rating.good': 'Good',
  'studentCourses.rating.fair': 'Fair',
  'studentCourses.rating.poor': 'Poor',
  'studentCourses.rating.placeholder': 'Add your feedback (optional)...',
  'studentCourses.rating.submitting': 'Submitting...',
  'studentCourses.rating.submit': 'Submit Rating',
  'studentCourses.toast.rated': 'Thank you for your rating!',
  'studentCourses.toast.ratedDesc': 'Your rating has been saved successfully',
  'studentCourses.toast.rateFailed': 'Failed to save rating',

  // P3.1.2 batch 7 — StudentProfile
  'studentProfile.subtitle': 'Manage your personal information',
  'studentProfile.stats.totalSessions': 'Total Sessions',
  'studentProfile.stats.learningHours': 'Learning Hours',
  'studentProfile.stats.coursesEnrolled': 'Courses Enrolled',
  'studentProfile.stats.totalSpent': 'Total Spent',
  'studentProfile.timezone.placeholder': 'Select timezone',
  'studentProfile.gender': 'Gender (optional)',
  'studentProfile.gender.placeholder': 'Select',
  'studentProfile.gender.male': 'Male',
  'studentProfile.gender.female': 'Female',
  'studentProfile.preferences.title': 'Learning Preferences',
  'studentProfile.preferences.subtitle': 'Tell us about your learning goals',
  'studentProfile.preferences.level': 'Current Level',
  'studentProfile.preferences.lang': 'Preferred Teaching Language',
  'studentProfile.preferences.duration': 'Preferred Session Duration',
  'studentProfile.preferences.interests': 'Learning Interests',
  'studentProfile.preferences.interestsPlaceholder': 'Quran, Tajweed, Arabic Language...',
  'studentProfile.preferences.interestsHint': 'Separate interests with commas',
  'studentProfile.preferences.goals': 'Learning Goals',
  'studentProfile.preferences.goalsPlaceholder': 'What do you want to achieve through your studies?',
  'studentProfile.lang.arabic': 'Arabic',
  'studentProfile.lang.english': 'English',
  'studentProfile.lang.urdu': 'Urdu',
  'studentProfile.lang.indonesian': 'Indonesian',
  'studentProfile.duration.minutes': 'minutes',
  'studentProfile.memberSince': 'Member since',

  // P3.1.2 batch 8 — Courses listing page
  'courses.page.title': 'Courses',
  'courses.page.subtitle': 'Discover our structured courses in Tajweed, Hifz, Tafsir, and Arabic language',
  'courses.filter.heading': 'Filter Results',
  'courses.filter.searchPlaceholder': 'Search courses...',
  'courses.filter.searchAriaLabel': 'Search courses',
  'courses.filter.allCategories': 'All Categories',
  'courses.filter.allLevels': 'All Levels',
  'courses.card.viewCourse': 'View Course',
  'courses.error.title': 'Error loading courses',
  'courses.error.description': 'Please try again later',
  'courses.empty.title': 'No courses found',
  'courses.empty.description': 'Try adjusting your search filters',
  'courses.rating.outOf5Stars': 'out of 5 stars',
  'courses.rating.reviews': 'reviews',
  'courses.pagination.showing': 'Showing',
  'courses.pagination.of': 'of',
  'courses.pagination.coursesNoun': 'courses',

  // P3.1.2 batch 8 — FamilyDashboard
  'family.toast.accountCreated': 'Family account created',
  'family.toast.childAdded': 'Child added successfully',
  'family.toast.childRemoved': 'Child removed',
  'family.createAccount.title': 'Create a Family Account',
  'family.createAccount.description': "Create a family account to manage your children's learning and track their progress in one place.",
  'family.createAccount.button': 'Create Family Account',
  'family.stats.children': 'Children',
  'family.stats.totalSessions': 'Total Sessions',
  'family.stats.surahsMemorized': 'Surahs Memorized',
  'family.stats.totalSpent': 'Total Spent',
  'family.children.heading': 'My Children',
  'family.children.addChild': 'Add Child',
  'family.children.empty.title': 'No children yet',
  'family.children.empty.description': 'Add your first child to start the learning journey',
  'family.children.completed': 'Completed:',
  'family.children.surahs': 'Surahs',
  'family.children.streak': 'Streak',
  'family.children.upcoming': 'Upcoming',
  'family.dialog.title': 'Add Child',
  'family.dialog.subtitle': "Enter your child's information",
  'family.dialog.nameEn': 'Name (English)',
  'family.dialog.nameAr': 'Name (Arabic)',
  'family.dialog.namePlaceholder': "Child's name",
  'family.dialog.dateOfBirth': 'Date of Birth',
  'family.dialog.learningLevel': 'Learning Level',
  'family.dialog.addButton': 'Add',
  'family.heading': 'Family Dashboard',
  'family.subheading': "Manage your children's learning in one place",
  'family.stats.ayahs': 'Ayahs Memorized',
  'family.stats.upcoming': 'Upcoming Sessions',
  'family.dialog.gender': 'Gender',
  'family.dialog.genderMale': 'Boy',
  'family.dialog.genderFemale': 'Girl',
  'family.dialog.levelHafiz': 'Hafiz',
  'family.dialog.teacher': 'Teacher',
  'family.dialog.teacherPlaceholder': 'Choose a teacher',
  'family.dialog.teacherNone': 'Decide later',
  'family.dialog.teacherHelp': 'You can change this at any time.',
  'family.dialog.nameRequired': 'Please enter your child’s name',
  'family.children.teacher': 'Teacher',
  'family.children.noTeacher': 'No teacher chosen yet',
  'family.children.chooseTeacher': 'Choose teacher',
  'family.children.changeTeacher': 'Change teacher',
  'family.children.book': 'Book a session',
  'family.children.remove': 'Remove child',
  'family.children.removeConfirm': 'Remove this child from your family account?',
  'family.children.ayahs': 'Ayahs',
  'family.children.pendingReviews': 'Reviews due',
  'family.children.nextSession': 'Next session',
  'family.children.noSessions': 'No sessions booked',
  'family.teacherDialog.title': 'Choose a teacher',
  'family.teacherDialog.subtitle': 'Pick the teacher who will work with',
  'family.teacherDialog.search': 'Search teachers…',
  'family.teacherDialog.empty': 'No teachers match your search',
  'family.teacherDialog.assign': 'Assign',
  'family.teacherDialog.clear': 'Remove teacher',
  'family.teacherDialog.perHour': '/hr',
  'family.toast.teacherAssigned': 'Teacher updated',
  'family.toast.error': 'Something went wrong',
  'family.loginPrompt': 'Sign in to your family account to continue.',

  // ===========================================
  // Teacher — Payout Details
  // ===========================================
  'payout.nav': 'Payout Details',
  'payout.heading': 'Payout Details',
  'payout.subheading': 'Tell us where to send your earnings',
  'payout.method': 'Payout Method',
  'payout.methodHelp': 'Choose how you would like to be paid. You can change this at any time.',
  'payout.method.bank': 'Bank Transfer',
  'payout.method.paypal': 'PayPal',
  'payout.method.wise': 'Wise',
  'payout.method.westernUnion': 'Western Union',
  'payout.method.moneyGram': 'MoneyGram',
  'payout.method.mobileWallet': 'Mobile Wallet',
  'payout.bankName': 'Bank Name',
  'payout.bankAccountName': 'Account Holder Name',
  'payout.bankAccountNumber': 'Account Number',
  'payout.bankIban': 'IBAN',
  'payout.bankSwift': 'SWIFT / BIC Code',
  'payout.bankCountry': 'Bank Country',
  'payout.paypalEmail': 'PayPal Email',
  'payout.wiseEmail': 'Wise Email',
  'payout.recipientName': 'Full Legal Name',
  'payout.recipientNameHelp': 'Exactly as it appears on your ID — transfers are rejected if it does not match.',
  'payout.recipientCountry': 'Country',
  'payout.recipientCity': 'City',
  'payout.recipientPhone': 'Phone Number',
  'payout.walletProvider': 'Wallet Provider',
  'payout.walletNumber': 'Wallet Number',
  'payout.save': 'Save Payout Details',
  'payout.saving': 'Saving…',
  'payout.saved': 'Payout details saved',
  'payout.saveFailed': 'Could not save your payout details',
  'payout.incomplete': 'Your payout details are incomplete — we cannot pay you until these are filled in.',
  'payout.complete': 'Your payout details are complete.',
  'payout.privacyNote': 'Only you and the finance team can see these details. They are never shown on your public profile.',
  'payout.optional': 'optional',

  // ===========================================
  // Admin — Payouts
  // ===========================================
  'adminPayouts.heading': 'Teacher Payouts',
  'adminPayouts.subheading': 'Run the month, check where each payout goes, and record the transfer',
  'adminPayouts.runMonth': 'Generate Last Month',
  'adminPayouts.generated': 'Payouts generated',
  'adminPayouts.blockedSuffix': 'blocked on missing details',
  'adminPayouts.unpayableWarning': 'payout(s) cannot be paid — the teacher has not supplied complete details.',
  'adminPayouts.filterStatus': 'Filter by status',
  'adminPayouts.allStatuses': 'All statuses',
  'adminPayouts.total': 'payouts',
  'adminPayouts.sessions': 'sessions',
  'adminPayouts.gross': 'Gross',
  'adminPayouts.noDetails': 'No payout details',
  'adminPayouts.viewDestination': 'Where to send',
  'adminPayouts.refreshDetails': 'Refresh details',
  'adminPayouts.detailsRefreshed': 'Payout details refreshed',
  'adminPayouts.stillIncomplete': 'The teacher still has not supplied complete details',
  'adminPayouts.approve': 'Approve',
  'adminPayouts.approved': 'Payout approved',
  'adminPayouts.cannotApprove': 'Cannot approve until the teacher completes their payout details.',
  'adminPayouts.markPaid': 'Mark as paid',
  'adminPayouts.markedPaid': 'Payout marked as paid',
  'adminPayouts.confirmPaid': 'Confirm payment',
  'adminPayouts.reference': 'Transaction reference',
  'adminPayouts.referenceHelp': 'The bank or transfer reference — this is the only link between this record and the real payment.',
  'adminPayouts.destinationTitle': 'Where to send this payout',
  'adminPayouts.noDestination': 'No destination recorded',
  'adminPayouts.empty.title': 'No payouts yet',
  'adminPayouts.empty.description': 'Generate last month to raise payouts for teachers with paid sessions',
  'adminPayouts.error': 'Something went wrong',
  'adminPayouts.prev': 'Previous page',
  'adminPayouts.next': 'Next page',


  // P3.1.2 batch 9 — CourseDetail
  'courseDetail.toast.enrollSuccess': 'Successfully enrolled!',
  'courseDetail.toast.enrollFailed': 'Failed to enroll',
  'courseDetail.seo.description': 'Quran course with a certified teacher',
  'courseDetail.notFound.title': 'Course not found',
  'courseDetail.notFound.description': "We couldn't find this course",
  'courseDetail.notFound.action': 'Browse Courses',
  'courseDetail.backToCourses': 'Back to Courses',
  'courseDetail.badge.featured': 'Featured',
  'courseDetail.stats.enrolled': 'enrolled',
  'courseDetail.stats.hours': 'hours',
  'courseDetail.preview.ariaLabel': 'Watch course preview',
  'courseDetail.tabs.description': 'Description',
  'courseDetail.tabs.whatYouLearn': "What You'll Learn",
  'courseDetail.tabs.syllabus': 'Syllabus',
  'courseDetail.tabs.prerequisites': 'Prerequisites',
  'courseDetail.tabs.whoThisIsFor': 'Who This Is For',
  'courseDetail.lesson.lockedNote': 'Lesson details available after enrollment',
  'courseDetail.pricing.off': 'OFF',
  'courseDetail.pricing.signUpToEnroll': 'Sign up to Enroll',
  'courseDetail.card.lessons': 'Lessons',
  'courseDetail.card.enrolled': 'Enrolled',
  'courseDetail.card.completed': 'Completed',

  // Mushaf viewer (Phase 2 — docs/MUSHAF-VIEWER-PLAN.md)
  'mushaf.pageMode': 'Page',
  'mushaf.textMode': 'Text',
  'mushaf.page': 'Page',
  'mushaf.juz': 'Juz',
  'mushaf.searchSurah': 'Search surah...',
  'mushaf.nextPage': 'Next page',
  'mushaf.prevPage': 'Previous page',
  'mushaf.nextSurah': 'Next surah',
  'mushaf.prevSurah': 'Previous surah',
  'mushaf.translation': 'Translation',
  'mushaf.bookmarkPage': 'Bookmark this page',
  'mushaf.bookmarks': 'Bookmarks',
  'mushaf.playAyah': 'Play ayah',
  'mushaf.repeatAyah': 'Repeat ayah',
  'mushaf.memorized': 'Memorized',
  'mushaf.inProgress': 'In progress',
  'mushaf.needsReview': 'Needs review',
  'mushaf.noAyahs': 'No ayahs available',
  'mushaf.attribution': 'Mushaf pages courtesy of the Ayat project, King Saud University',
  'mushaf.markHifz': 'Mark hifz',
  'mushaf.fromAyah': 'From ayah',
  'mushaf.toAyah': 'To ayah',
  'mushaf.save': 'Save',
  'mushaf.hifzSaved': 'Hifz progress saved',
  'mushaf.hifzSaveFailed': 'Could not save hifz progress',
  'mushaf.openInMushaf': 'Open in Mushaf',
  'mushaf.pageAlt': 'Mushaf page',
  'mushaf.pauseAyah': 'Pause ayah',
  'send': 'Send',
  'unread': 'Unread',
  'chat.studentSubtitle': 'Communicate with your teachers',
  'chat.teacherSubtitle': 'Communicate with your students',
  'chat.noMessagesYet': 'No messages yet — start the conversation',
  'adminUsers.all': 'All',
  'adminUsers.teacher': 'Teacher',
  'adminUsers.student': 'Student',
  'adminUsers.active': 'Active',
  'adminUsers.approved': 'Approved',
  'adminUsers.pending': 'Pending',
  'adminUsers.rejected': 'Rejected',
  'adminUsers.suspended': 'Suspended',
  'adminUsers.country': 'Country',
  'adminUsers.sessions': 'Sessions',
  'adminUsers.empty': 'No matching users',
  'adminUsers.usersSuffix': 'users',
  'adminUsers.prevPage': 'Previous page',
  'adminUsers.nextPage': 'Next page',

  // Google sign-in
  'auth.google.continue': 'Continue with Google',
  'auth.google.or': 'or',
  'auth.google.unavailable': 'Google sign-in is unavailable right now',
  'auth.google.callback.completing': 'Completing sign-in…',
  'auth.google.callback.chooseRole': 'How would you like to join?',
  'auth.google.callback.chooseRoleDesc': 'Your Google account is connected. Choose how you want to use the platform.',
  'auth.google.callback.asStudent': 'Join as a Student',
  'auth.google.callback.asTeacher': 'Apply as a Teacher',
  'auth.google.callback.pendingTitle': 'Application received',
  'auth.google.callback.pendingDesc': 'Your teacher application is pending approval. You will be notified once approved.',
  'auth.google.callback.error': 'Google sign-in failed. Please try again.',
  'auth.google.callback.backToLogin': 'Back to login',
  'auth.google.callback.goHome': 'Go to homepage',

  // ===========================================
  // Quran for Kids landing page (/quran-for-kids)
  // Ad landing page for the Children campaign.
  // ===========================================
  'seo.kids.title': 'Online Quran Classes for Kids — 1-on-1 Teachers | Hudan',
  'seo.kids.description': 'Live one-to-one Quran lessons for children aged 4–15. Ijazah-verified teachers, female teachers available, and a parent account that keeps you in control.',
  'seo.kids.keywords': 'quran classes for kids, online quran teacher for kids, quran for children, kids quran memorization, noorani qaida for kids, female quran teacher, learn quran for kids online, children tajweed lessons, quran hifz for children',

  'kids.breadcrumb': 'Quran for Kids',

  'kids.hero.badge': 'Ages 4–15 · One-to-one',
  'kids.hero.title': 'Online Quran Classes for Kids',
  'kids.hero.subtitle': 'One-to-one lessons with teachers who specialise in children — Noorani Qaida, reading, Tajweed and Hifz, taught at your child\'s pace and around your family\'s week.',
  'kids.hero.ctaPrimary': 'Create a parent account',
  'kids.hero.ctaSecondary': 'Meet the teachers',
  'kids.hero.trust1': 'Ijazah-verified teachers',
  'kids.hero.trust2': 'Female teachers available',
  'kids.hero.trust3': 'Your child needs no login',
  'kids.hero.trust4': 'One-to-one, never a group',

  'kids.stats.teachersLabel': 'Teachers who specialise in children',
  'kids.stats.agesValue': '4–15',
  'kids.stats.agesLabel': 'Ages taught',
  'kids.stats.ratingLabel': 'Average teacher rating',
  'kids.stats.formatValue': '1-on-1',
  'kids.stats.formatLabel': 'Every lesson',

  'kids.why.eyebrow': 'Why parents choose Hudan',
  'kids.why.title': 'Built for children, and for the parent booking the lesson',
  'kids.why.1.title': 'Teachers who specialise in children',
  'kids.why.1.desc': 'Holding a seven-year-old\'s attention is its own skill. Every teacher shown on this page lists children\'s Quran teaching as a specialty.',
  'kids.why.2.title': 'Female teachers for your daughters',
  'kids.why.2.desc': 'Most of our children\'s teachers are women. Choose the teacher yourself — nobody is assigned to your child without you.',
  'kids.why.3.title': 'Your child never needs a login',
  'kids.why.3.desc': 'You add your child as a profile on your own parent account. No password for them to lose, and no inbox for strangers to reach.',
  'kids.why.4.title': 'The right method for the right age',
  'kids.why.4.desc': 'Younger children begin with Noorani Qaida — letters and sounds before words. Older children move on to fluent reading, Tajweed rules and memorisation.',
  'kids.why.5.title': 'Progress you can see',
  'kids.why.5.desc': 'Your family dashboard lists every session booked and completed for each child, so you always know where they are up to.',
  'kids.why.6.title': 'Fits around school',
  'kids.why.6.desc': 'Teachers publish real availability across time zones. Book after school, at the weekend, or early before Fajr in Ramadan.',

  'kids.paths.eyebrow': 'Learning path',
  'kids.paths.title': 'Where your child starts depends on their age',
  'kids.paths.subtitle': 'The first lesson is where the teacher finds their level. These are the usual starting points.',
  'kids.paths.early.age': 'Ages 4–6',
  'kids.paths.early.title': 'First letters and sounds',
  'kids.paths.early.b1': 'Noorani Qaida from the Arabic alphabet',
  'kids.paths.early.b2': 'Short surahs learned by listening and repeating',
  'kids.paths.early.b3': 'Shorter lessons that match a young attention span',
  'kids.paths.middle.age': 'Ages 7–10',
  'kids.paths.middle.title': 'Reading with confidence',
  'kids.paths.middle.b1': 'Finishing Qaida and reading from the Mushaf',
  'kids.paths.middle.b2': 'The core Tajweed rules, applied while reading',
  'kids.paths.middle.b3': 'Memorising Juz Amma, surah by surah',
  'kids.paths.teen.age': 'Ages 11–15',
  'kids.paths.teen.title': 'Hifz and meaning',
  'kids.paths.teen.b1': 'Structured memorisation with a revision plan',
  'kids.paths.teen.b2': 'Full Tajweed, including the finer rules',
  'kids.paths.teen.b3': 'Understanding what they are reciting',

  'kids.courses.eyebrow': 'Courses',
  'kids.courses.title': 'Structured courses for younger learners',
  'kids.courses.viewAll': 'Browse all courses',
  'kids.courses.free': 'Free',
  'kids.courses.lessons': 'lessons',

  'kids.teachers.eyebrow': 'Teachers',
  'kids.teachers.title': 'Teachers who specialise in children',
  'kids.teachers.subtitle': 'Every teacher here lists children\'s Quran teaching among their specialties. Open a profile to see their experience, languages and availability.',
  'kids.teachers.viewAll': 'See all teachers',
  'kids.teachers.perHour': '/hour',
  'kids.teachers.ijazahVerified': 'Ijazah verified',
  'kids.teachers.trialFrom': 'Trial from',
  'kids.teachers.trialFree': 'Free trial',
  'kids.teachers.empty': 'No teachers to show right now. Browse all teachers instead.',
  'kids.teachers.error': 'We could not load teachers just now. Please try again shortly.',

  'kids.how.eyebrow': 'How it works',
  'kids.how.title': 'Four steps to the first lesson',
  'kids.how.1.title': 'Create a parent account',
  'kids.how.1.desc': 'It takes a minute. You are the account holder, and everything runs through you.',
  'kids.how.2.title': 'Add your child',
  'kids.how.2.desc': 'Their name, age and level. No email address and no password needed for them.',
  'kids.how.3.title': 'Choose a teacher',
  'kids.how.3.desc': 'Compare teachers who specialise in children by specialty, language, experience and rate.',
  'kids.how.4.title': 'Book the first lesson',
  'kids.how.4.desc': 'Pick a slot from the teacher\'s live calendar. The lesson runs in the browser — nothing to install.',

  'kids.safety.eyebrow': 'Safeguarding',
  'kids.safety.title': 'What we do because they are children',
  'kids.safety.1.title': 'Teachers are verified before they teach',
  'kids.safety.1.desc': 'Every teacher submits their Ijazah and identity documents for review before their profile is approved. Those documents stay private to the review team.',
  'kids.safety.2.title': 'The account is yours, not theirs',
  'kids.safety.2.desc': 'Children have no login of their own. Booking, payment and approval all happen from your parent account.',
  'kids.safety.3.title': 'Private one-to-one sessions',
  'kids.safety.3.desc': 'Lessons are one-to-one video sessions, and the meeting link is issued per session to the people on it.',
  'kids.safety.4.title': 'You choose, and you can change',
  'kids.safety.4.desc': 'You pick your child\'s teacher, and you can switch them to a different teacher whenever you want.',

  'kids.faq.eyebrow': 'For parents',
  'kids.faq.title': 'Questions parents ask first',
  'kids.faq.q1': 'What age can my child start?',
  'kids.faq.a1': 'Many families start at four or five with Noorani Qaida — the letters and their sounds. There is no fixed minimum: the teacher uses the first lesson to find out what your child can already do and starts from there.',
  'kids.faq.q2': 'Does my child need their own account?',
  'kids.faq.a2': 'No. You register as a parent and add your child as a profile on your account. They have no login, no password and no inbox — you book their lessons and follow their progress from your family dashboard.',
  'kids.faq.q3': 'Can I ask for a female teacher?',
  'kids.faq.a3': 'Yes. Most of the teachers who specialise in children\'s Quran on Hudan are women, and you choose the teacher yourself when you book — nobody is assigned to your child.',
  'kids.faq.q4': 'How long is a lesson, and how often?',
  'kids.faq.a4': 'Lessons are one-to-one and booked per session, so you set the pace. Teachers list the session length they teach in on their profile. Many families start with two or three lessons a week and adjust once they see how their child settles in.',
  'kids.faq.q5': 'What will my child actually learn?',
  'kids.faq.a5': 'It depends on age and level. Younger children work through Noorani Qaida and short surahs; the next stage is fluent reading from the Mushaf with the core Tajweed rules; older children move into structured memorisation with a revision plan.',
  'kids.faq.q6': 'Do you teach in English as well as Arabic?',
  'kids.faq.a6': 'Yes. Every teacher lists the languages they teach in, so a child growing up outside the Arab world can learn Quran from a teacher who explains in a language they are comfortable with.',
  'kids.faq.q7': 'What does it cost?',
  'kids.faq.a7': 'Each teacher sets their own hourly rate, shown on their profile. Most also offer a lower-priced trial session — and some a free one — so you can see whether your child gets on with them before you commit.',

  'kids.cta.title': 'Start with one lesson',
  'kids.cta.subtitle': 'Create your parent account, add your child, and book a trial session with a teacher who specialises in children.',
  'kids.cta.primary': 'Create a parent account',
  'kids.cta.secondary': 'Browse all teachers',

  // ===========================================
  // Student payments (/student/payments)
  // Pay for a booking the teacher has confirmed, and upload transfer proof.
  // ===========================================
  'pay.nav': 'Payments',
  'pay.title': 'Payments',
  'pay.subtitle': 'Settle confirmed bookings and keep track of what you have paid.',

  'pay.pending.title': 'Awaiting payment',
  'pay.pending.empty': 'Nothing to pay right now',
  'pay.pending.emptyHint': 'When a teacher confirms a booking it appears here with a payment deadline.',
  'pay.pending.with': 'With',
  'pay.pending.deadline': 'Pay by',
  'pay.pending.expired': 'Deadline passed',
  'pay.pending.daysLeft': 'days left',
  'pay.pending.hoursLeft': 'hours left',
  'pay.pending.minutesLeft': 'minutes left',
  'pay.pending.pay': 'Pay now',
  'pay.pending.awaitingVerification': 'Proof sent — awaiting verification',

  'pay.dialog.title': 'Pay for your session',
  'pay.dialog.method': 'How would you like to pay?',
  'pay.dialog.continue': 'Continue',
  'pay.dialog.noMethods': 'No payment method is available yet',
  'pay.dialog.noMethodsHint': 'Payments are not switched on for this platform yet. Please contact us to arrange payment for this booking.',
  'pay.dialog.cardUnavailable': 'Card payment is not available in the app yet — please choose bank transfer, or contact us.',
  'pay.dialog.loadError': 'We could not start this payment. Please try again shortly.',

  'pay.bank.title': 'Transfer the amount to this account',
  'pay.bank.bankName': 'Bank',
  'pay.bank.accountName': 'Account holder',
  'pay.bank.accountNumber': 'Account number',
  'pay.bank.iban': 'IBAN',
  'pay.bank.swift': 'SWIFT / BIC',
  'pay.bank.instructions': 'Instructions',
  'pay.bank.copy': 'Copy',
  'pay.bank.copied': 'Copied',
  'pay.bank.missing': 'The bank details are not filled in yet — please contact us before transferring.',

  'pay.proof.title': 'Then send us the receipt',
  'pay.proof.hint': 'Upload the transfer receipt and add the reference your bank gave you. An admin checks it and marks the session paid.',
  'pay.proof.reference': 'Bank reference (optional)',
  'pay.proof.referencePlaceholder': 'e.g. TRX-4471902',
  'pay.proof.file': 'Receipt',
  'pay.proof.choose': 'Choose a file',
  'pay.proof.submit': 'Send receipt',
  'pay.proof.submitting': 'Sending…',
  'pay.proof.needFile': 'Please attach the transfer receipt first.',
  'pay.proof.tooLarge': 'That file is larger than 5 MB. Please attach a smaller one.',
  'pay.proof.badType': 'Please attach an image or a PDF.',
  'pay.proof.done': 'Receipt received',
  'pay.proof.doneHint': 'We will verify the transfer and confirm your session. You will be notified as soon as it is done.',
  'pay.proof.close': 'Close',

  'pay.free.done': 'Nothing to pay — this session is already settled.',

  'pay.history.title': 'Payment history',
  'pay.history.empty': 'No payments yet',
  'pay.history.date': 'Date',
  'pay.history.amount': 'Amount',
  'pay.history.method': 'Method',
  'pay.history.status': 'Status',

  'pay.status.Pending': 'Pending',
  'pay.status.Processing': 'Processing',
  'pay.status.Completed': 'Paid',
  'pay.status.Failed': 'Failed',
  'pay.status.Refunded': 'Refunded',
  'pay.status.Cancelled': 'Cancelled',

  'pay.admin.verify': 'Verify',
  'pay.admin.reject': 'Reject',
  'pay.admin.actions': 'Actions',
  'pay.admin.proof': 'Receipt',
  'pay.admin.viewProof': 'View receipt',
  'pay.admin.noProof': 'No receipt uploaded',
  'pay.admin.reference': 'Reference',
  'pay.admin.verifyTitle': 'Verify this payment?',
  'pay.admin.verifyBody': 'This marks the payment received and the session paid. Check the receipt against your bank statement first.',
  'pay.admin.verifyConfirm': 'Yes, mark as received',
  'pay.admin.rejectTitle': 'Reject this payment',
  'pay.admin.rejectBody': 'The student is told why, and the booking stays unpaid.',
  'pay.admin.rejectReason': 'Reason',
  'pay.admin.rejectPlaceholder': 'e.g. No transfer found matching this reference',
  'pay.admin.rejectConfirm': 'Reject payment',
  'pay.admin.verified': 'Payment verified',
  'pay.admin.rejected': 'Payment rejected',
  'pay.admin.needReason': 'Please give a reason.',
  'pay.admin.cancel': 'Cancel',

  // ===========================================
  // Teacher booking inbox (/teacher/bookings)
  // Where a student's request gets confirmed or turned down.
  // ===========================================
  'tbk.nav': 'Booking requests',
  'tbk.title': 'Booking requests',
  'tbk.subtitle': 'Confirm a request and the student is asked to pay. Nothing is scheduled until you do.',

  'tbk.tab.pending': 'Needs your answer',
  'tbk.tab.awaiting': 'Awaiting payment',
  'tbk.tab.all': 'All requests',

  'tbk.empty.pending': 'No requests waiting',
  'tbk.empty.pendingHint': 'New booking requests from students land here.',
  'tbk.empty.awaiting': 'Nothing awaiting payment',
  'tbk.empty.awaitingHint': 'Requests you have confirmed appear here until the student pays.',
  'tbk.empty.all': 'No requests yet',

  'tbk.card.requested': 'Requested',
  'tbk.card.duration': 'Duration',
  'tbk.card.minutes': 'min',
  'tbk.card.type': 'Type',
  'tbk.card.message': 'Student note',
  'tbk.card.payBy': 'Student must pay by',
  'tbk.card.expired': 'Payment deadline passed',

  'tbk.action.confirm': 'Confirm',
  'tbk.action.reject': 'Decline',

  'tbk.confirm.title': 'Confirm this booking?',
  'tbk.confirm.body': 'This reserves the slot and asks the student to pay. The session is created straight away but stays unpaid until they do.',
  'tbk.confirm.response': 'Message to the student (optional)',
  'tbk.confirm.placeholder': 'e.g. Looking forward to it — please bring your Mushaf.',
  'tbk.confirm.submit': 'Confirm booking',

  'tbk.reject.title': 'Decline this booking',
  'tbk.reject.body': 'The student is told why, and the slot is released.',
  'tbk.reject.reason': 'Reason',
  'tbk.reject.placeholder': 'e.g. I am not available at that time — could you try the evening?',
  'tbk.reject.submit': 'Decline booking',
  'tbk.reject.needReason': 'Please give the student a reason.',

  'tbk.cancel': 'Cancel',
  'tbk.toast.confirmed': 'Booking confirmed — the student has been asked to pay.',
  'tbk.toast.rejected': 'Booking declined.',
  'tbk.toast.error': 'That did not go through. Please try again shortly.',

  'tbk.status.Pending': 'Awaiting your answer',
  'tbk.status.Confirmed': 'Confirmed',
  'tbk.status.Payment Pending': 'Awaiting payment',
  'tbk.status.Paid': 'Paid',
  'tbk.status.Completed': 'Completed',
  'tbk.status.Cancelled': 'Cancelled',
  'tbk.status.Rejected': 'Declined',
  'tbk.status.Expired': 'Expired',

  // ===========================================
  // Admin → Control Panel → Payments (wired to Hudan Settings)
  // ===========================================
  'admin.pay.bankName': 'Bank name',
  'admin.pay.accountName': 'Account holder name',
  'admin.pay.accountNumber': 'Account number',
  'admin.pay.iban': 'IBAN',
  'admin.pay.swift': 'SWIFT / BIC',
  'admin.pay.instructionsEn': 'Payment instructions (English)',
  'admin.pay.instructionsAr': 'Payment instructions (Arabic)',
  'admin.pay.studentsSeeHint': 'Students who choose bank transfer see these details on their payment page, so enter them exactly as they appear on the account.',
  'admin.pay.secretStored': 'Stored — leave blank to keep the current value',
  'admin.pay.saved': 'Payment settings saved',
  'admin.pay.saveFailed': 'Could not save payment settings',
  'admin.pay.noChanges': 'Nothing to save',
  'admin.pay.needBankDetails': 'Enter the bank details before enabling manual payments — students would see an empty payment page.',
  'admin.pay.loadFailed': 'Could not load payment settings',
  'tapDescription': 'Accept mada, KNET and Benefit card payments across the GCC via Tap',
  'enableTap': 'Enable Tap Payments',
  'enableTapDescription': 'Students will be able to pay with GCC debit and credit cards',
  'tapPublishableKey': 'Tap Publishable Key',
  'tapSecretKey': 'Tap Secret Key',
  'tapWebhookSecret': 'Tap Webhook Secret',

  // Phase 1 backlog (2026-09-05): refunds, verification nag, payment window
  'pay.history.refund': 'Refund',
  'pay.refund.request': 'Request refund',
  'pay.refund.title': 'Request a refund',
  'pay.refund.hint': 'Tell us what went wrong. An admin reviews every request; the amount that applies is',
  'pay.refund.reason': 'Reason',
  'pay.refund.reasonPlaceholder': 'e.g. the teacher did not join the session',
  'pay.refund.submit': 'Send request',
  'pay.refund.sent': 'Refund request submitted',
  'pay.refund.failed': 'Could not submit the refund request',
  'pay.refund.status.Pending': 'Refund requested',
  'pay.refund.status.Approved': 'Refund approved',
  'pay.refund.status.Processing': 'Refund processing',
  'pay.refund.status.Completed': 'Refunded',
  'pay.refund.status.Rejected': 'Refund declined',
  'pay.refund.why.dispute_window_closed': 'Refund window closed (7 days)',
  'pay.refund.why.policy_zero': 'No refund: cancelled under 12h before',
  'pay.refund.why.refund_rejected': 'Refund already reviewed',
  'pay.refund.why.cancel_instead': 'Cancel the session to get a refund',
  'verify.nag.title': 'Please verify your email address',
  'verify.nag.body': 'We sent a verification link to',
  'sending': 'Sending...',
  'verify.nag.resend': 'Resend email',
  'verify.nag.sentShort': 'Sent',
  'verify.nag.sent': 'Verification email sent. Please check your inbox.',
  'verify.nag.failed': 'Could not send the verification email. Try again in a while.',
  'verify.nag.dismiss': 'Hide for now',
  'admin.pay.window.title': 'Payment window',
  'admin.pay.window.description': 'How long a student has to pay after the teacher confirms a booking. When it runs out, the slot is released and the student is notified.',
  'admin.pay.window.label': 'Hours to pay after confirmation',
  'admin.pay.window.hint': 'Leave empty for the default (24 hours). 1 to 168 hours.',
  'admin.pay.window.invalid': 'Payment window must be a whole number between 1 and 168 hours',
  // Parent payment path (2026-09-05)
  'family.payments.nav': 'Payments',
  'family.payments.heading': 'Family Payments',
  'family.payments.subheading': 'Pay for your children\'s confirmed sessions and keep track of what you have paid.',
  'pay.pending.for': 'For',
  'pay.history.for': 'For',
  // Session join (2026-09-05)
  'session.join.button': 'Join',
  'session.join.openExternal': 'Open the meeting link',
  'session.join.externalHint': 'Your teacher set up this session on an external meeting service. It opens in a new tab.',
  'session.join.connecting': 'Connecting you to the room...',
  'session.join.retry': 'Try again',
  'session.join.not_found': 'Session not found',
  'session.join.forbidden': 'You are not a participant in this session',
  'session.join.closed': 'This session has already ended',
  'session.join.no_room': 'The meeting room is not ready yet. It is created once the session is paid.',
  'session.join.too_early': 'You can join 15 minutes before the session starts',
  'session.join.ended': 'This session\'s time has passed',
  'session.join.token_failed': 'Could not open the video room. Please try again in a moment.',
  'session.join.error': 'Could not open the session. Please try again.',
  // Wallet checkout (2026-09-05)
  'pay.method.wallet': 'Wallet balance',
  'pay.method.walletBalance': 'Available:',
  'pay.method.walletInsufficient': 'Not enough balance in this currency. Available:',
  'pay.wallet.paid': 'Paid from your wallet balance',
  'admin.finance.otherCurrencies': 'Also received in other currencies (not included above):',
  // Password settings (2026-09-05)
  'settings.password.title': 'Change password',
  'settings.password.description': 'Choose a new password for your account.',
  'settings.password.current': 'Current password',
  'settings.password.new': 'New password',
  'settings.password.confirm': 'Confirm new password',
  'settings.password.minLength': 'At least 8 characters.',
  'settings.password.mismatch': 'The passwords do not match.',
  'settings.password.submit': 'Update password',
  'settings.password.updated': 'Password updated',
  'settings.password.failed': 'Could not change the password. Check your current password and try again.',
  // Teacher homework + admin courses (2026-09-05)
  'thw.nav': 'Homework',
  'thw.title': 'Homework',
  'thw.subtitle': 'Assign memorisation, revision and practice, then grade what your students submit.',
  'thw.assign': 'Assign homework',
  'thw.assignHint': 'The student sees it on their Homework page and submits from there.',
  'thw.list': 'Assignments',
  'thw.empty': 'No homework yet',
  'thw.emptyHint': 'Assign the first task from the button above.',
  'thw.review': 'Grade',
  'thw.submitReview': 'Save grade',
  'thw.student': 'Student',
  'thw.pickStudent': 'Choose a student',
  'thw.typeLabel': 'Type',
  'thw.surah': 'Surah',
  'thw.ayah': 'Ayah',
  'thw.fromAyah': 'From ayah',
  'thw.toAyah': 'To ayah',
  'thw.due': 'Due',
  'thw.instructions': 'Instructions (optional)',
  'thw.selfAssessment': 'Self-assessment',
  'thw.timeSpent': 'Time spent',
  'thw.minutes': 'min',
  'thw.rating': 'Grade',
  'thw.pickRating': 'Choose a grade',
  'thw.feedback': 'Feedback for the student (optional)',
  'thw.toast.assigned': 'Homework assigned',
  'thw.toast.assignFailed': 'Could not assign the homework',
  'thw.toast.reviewed': 'Grade saved',
  'thw.toast.reviewFailed': 'Could not save the grade',
  'thw.status.all': 'All',
  'thw.status.Assigned': 'Assigned',
  'thw.status.In Progress': 'In progress',
  'thw.status.Submitted': 'Submitted',
  'thw.status.Reviewed': 'Graded',
  'thw.status.Overdue': 'Overdue',
  'thw.type.Memorization': 'Memorisation',
  'thw.type.Revision': 'Revision',
  'thw.type.Tajweed Practice': 'Tajweed practice',
  'thw.type.Recitation': 'Recitation',
  'thw.type.Listening': 'Listening',
  'thw.rating.Excellent': 'Excellent',
  'thw.rating.Good': 'Good',
  'thw.rating.Needs Practice': 'Needs practice',
  'thw.rating.Not Ready': 'Not ready',
  'admin.courses.title': 'Courses',
  'admin.courses.directory': 'Course directory',
  'admin.courses.description': 'Every course on the platform. Teachers create and edit their own courses from the teacher portal.',
  'admin.courses.search': 'Search by title or teacher',
  'admin.courses.loadFailed': 'Could not load courses',
  'admin.courses.empty': 'No courses match',
  'admin.courses.featured': 'Featured',
  'admin.courses.free': 'Free',
  'admin.courses.view': 'View',
  'admin.courses.col.title': 'Title',
  'admin.courses.col.teacher': 'Teacher',
  'admin.courses.col.level': 'Level',
  'admin.courses.col.price': 'Price',
  'admin.courses.col.students': 'Students',
  'admin.courses.col.status': 'Status',
  'admin.courses.col.actions': 'Actions',
  'admin.courses.status.all': 'All statuses',
  'admin.courses.status.Published': 'Published',
  'admin.courses.status.Pending Review': 'Pending review',
  'admin.courses.status.Draft': 'Draft',
  'admin.courses.status.Archived': 'Archived',
};
